/* eslint-disable no-await-in-loop */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';

// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
//   utils
import { fData } from 'src/utils/format-number';
import MaskedInput from 'src/utils/MaskedInput';
// components
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import { UploadBox } from 'src/components/upload';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { _tags } from 'src/_mock';
import FormProvider, {
  RHFTextField,
  RHFAutocomplete,
  RHFRadioGroup,
  RHFUploadBox,
  RHFUploadAvatar,
} from 'src/components/hook-form';
import {
  Alert,
  Backdrop,
  Chip,
  CircularProgress,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  InputAdornment,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Switch,
  Tooltip,
  Autocomplete,
  TextField,
  Container,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import axiosInstance from 'src/api/axiosInstance';
import ListboxComponent from 'src/components/virtualized-autocomplete/autocomplete-virtualized';
import { blockInvalidChar } from 'src/helper/blockInvalidCharNumFld';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
import { isValid, parseISO } from 'date-fns';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';
import { decryptData, encryptData } from 'src/utils/Crypto';
import LinearAlternativeLabel from './linear-alternative-label-stepper';
import CandNewEditEduCompo from './cand-newEdit-edu-compo';
import CandNewEditExpCompo from './cand-newEdit-exp-compo';
import CandNewEditCertiCompo from './cand-newEdit-certi-compo';
import CandNewEditRefCompo from './cand-newEdit-ref-compo';

export default function CandidateNewEditForm({
  currentCand,
  currentCandPrefLoc,
  currentCandEduDtl,
  currentCandSkils,
  currentCandCertDtl,
  currentCandExpDtl,
  currentCandRefDtl,
  currentCandView,
  disabled,
  fromInterviewList,
}) {
  const token = sessionStorage.getItem('token');
  const loadingSend = useBoolean();
  const quickAutoFill = useBoolean();
  const confirm = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  const [rFileNm, setRFileNm] = useState('');
  const [canid, setCanid] = useState();
  const [cPrefLoc, setCPrefLoc] = useState([]);
  const [cEduDtl, setCEduDtl] = useState([]);
  const [cPskl, setCPSkl] = useState([]);
  const [cSskl, setCSSkl] = useState([]);
  const [cExpDtl, setCExpDtl] = useState([]);
  const [cRefDtl, setCRefDtl] = useState([]);
  const [cCertDtl, setCCertDtl] = useState([]);
  const [candEmailArr, setCandEmailArr] = useState([]);
  const [candUniqNoArr, setCandUniqNoArr] = useState([]);
  const [editResume, setEditResume] = useState(false);
  const [resumeTyp, setResumeTyp] = useState('');
  const [fileToAutoFill, setFileToAutoFill] = useState(null);
  const [openPositionsArr, setOpenPositionsArr] = useState([]);
  const [isResumeProcessing, setIsResumeProcessing] = useState(false);
  const router = useRouter();
  const fileInputRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const subscr = JSON.parse(localStorage.getItem('selectedSubscrSite'));
  const [curCandPic, setCurCandPic] = useState(false);
  const handleApiError = useNavigateErrorHandler();
  const [isFileTooLarge, setIsFileTooLarge] = useState(false);
  const maxSizeOfDocs = useSelector((state) => state.tenantPreference?.maxSizeOfDocuments || 3);
  const [isProfilePhotoRemoved, setIsProfilePhotoRemoved] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [tagEmail, setTagEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [uploadClick, setUploadClick] = useState(true);

  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  const [isAutoFilled, setIsAutoFilled] = useState(false);

  const openConfirmDialog = () => setConfirmOpen(true);
  const closeConfirmDialog = () => setConfirmOpen(false);

  // stepper Form Components
  const steps = [
    'Basic Details',
    'Personal Details',
    'Professional Details',
    'Education Details',
    'Certification Details',
    'Experience Details',
    'Reference Details',
  ];

  const stepsvalidator = [
    { label: 'Basic Details', fields: { resumeUpload: '', srcofhire: '', positionName: '' } },
    {
      label: 'Personal Details',
      fields: {
        fname: '',
        lname: '',
        email: '',
        mobno: '',
        gender: '',
        cuurntloc: '',
        uniqueno: '',
      },
    },
    { label: 'Professional Details', fields: { primaryskl: '', candQal: '', canjoinby: '', resigneddate: '' } },
    { label: 'Education Details', fields: { candEdu: '' } },
    { label: 'Certification Details', fields: { candCert: '' } },
    { label: 'Experience Details', fields: { candExp: '' } },
    { label: 'Reference Details', fields: { candRef: '' } },
  ];

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState();
  const [stepCompletionStatus, setStepCompletionStatus] = useState(
    new Array(steps.length).fill(null) // Use `null` instead of `false`
  );

  const [isSavingOnly, setIsSavingOnly] = useState(false);
  const [isSavingNext, setIsSavingNext] = useState(false);
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);
  const [savingAction, setSavingAction] = useState(null); // null, 'saveOnly', or 'saveNext'
  const confirmFinalSubmit = useBoolean();

  const [progress, Setprogress] = useState(0);
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  const handleFileDropWrapper = (e) => {
    setIsDragOver(false);
  };

  const [switchState, setSwitchState] = useState({
    experience: false,
  });

  const aadhaarSchema = Yup.string()
    .matches(
      /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
      'Aadhaar number is not valid (e.g., 234512341234)'
    )
    .nullable(); // Optional validation for Aadhar format

  const panSchema = Yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'PAN card number is not valid (e.g., ABCDE1234F)')
    .nullable();

  const baseSchema = Yup.object().shape({
    ...(activeStep === 0 && {
      positionName: Yup.object().nullable().test(
        'is-position-required',
        'Position applied for is required',
        (value, testContext) => {
          const { currentCand } = testContext.options.context || {};
          if (currentCand?.isImportedEmployee || currentCand?.status === 'Joined') {
            return true;
          }
          return !!value;
        }
      ),
      srcofhire: Yup.object().required('Source of hire is required'),
      srcofhireNm: Yup.string()
        .max(100, 'Source name must not exceed 100 characters')
        .test(
          'no-spaces-mid',
          'Source name cannot be only blank spaces or start/end with blank spaces (e.g., " Naukri " is wrong)',
          (value) => {
            if (!value) return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Source name cannot contain numbers or special characters (e.g., "Naukri23", "@#TimesJobs" are wrong)'
        ),
    }),

    ...(activeStep >= 1 && {
      fname: Yup.string()
        .required('First name is required. For example: Rajesh')
        .max(100, 'First name must not exceed 100 characters. For example: Rajesh or Priya')
        .test(
          'no-spaces',
          'First name cannot be only blank spaces or start/end with blank spaces. For example: "Rajesh" is valid, but "  Rajesh  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'First name cannot contain numbers or special characters. For example: "Rajesh" is valid, but "Rajesh123" or "Rajesh@#" is not.'
        ),

      mname: Yup.string()
        .max(100, 'Middle name must not exceed 100 characters. For example: Kumar')
        .test(
          'no-spaces-mid',
          'Middle name cannot be only blank spaces or start/end with blank spaces. For example: "Kumar" is valid, but "  Kumar  " is not.',
          (value) => {
            if (!value) return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Middle name cannot contain numbers or special characters. For example: "Kumar" is valid, but "Kumar123" or "Kumar@#" is not.'
        ),

      lname: Yup.string()
        .required('Last name is required. For example: Gupta')
        .max(100, 'Last name must not exceed 100 characters. For example: Gupta or Sharma')
        .test(
          'no-spaces',
          'Last name cannot be only blank spaces or start/end with blank spaces. For example: "Gupta" is valid, but "  Gupta  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Last name cannot contain numbers or special characters. For example: "Gupta" is valid, but "Gupta123" or "Gupta@#" is not.'
        ),

      email: Yup.string()
        .required('Email is required')
        .max(100, 'Email must not exceed 100 characters')
        .matches(
          /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
          'Email must be a valid format (e.g., user@example.com)'
        )
        .test(
          'unique',
          'Email already exists',
          async (value) => !candEmailArr.includes(value) // For new candidates
        ),

      mobno: Yup.string()
        .required('Mobile number is required. For example: 9876543210')
        .max(12, 'Enter a valid mobile number. For example: 9876543210')
        .min(10, 'Enter a valid mobile number. For example: 9876543210')
        .matches(
          /^[0-9]+$/,
          'Mobile number cannot contain + or - signs. For example: "9876543210" is valid, but "+919876543210" is not.'
        )
        .test(
          'phncode-required',
          'Country Code is required. For example: "+91" for India',
          (value, context) => {
            const { phncode } = context.parent;
            if (!phncode) {
              return false;
            }
            return true;
          }
        ),
      gender: Yup.object().required('Gender is required'),
      cuurntloc: Yup.object().required('Current location is required'),

      currentcomp: Yup.string()
        .notRequired()
        .max(100, 'Current Employer must not exceed 100 characters')
        .test(
          'no-spaces-mid',
          'Current Employer cannot be only blank spaces or start/end with blank spaces (e.g., "  Infosys")',
          (value) => {
            if (!value) return true;
            return value.trim() !== '' && value === value.trim();
          }
        ),

      linkedinUrl: Yup.string()
        .notRequired()
        .test(
          'is-valid-url',
          'Enter a valid LinkedIn profile URL (e.g., "https://www.linkedin.com/in/firstname-lastname/")',
          (value) => {
            if (!value) return true;
            const regex =
              /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
            return regex.test(value) && value.includes('linkedin.com');
          }
        ),
    }),
    // if activeStep ==2 then only below fields Validation will triggered it changed from Sprint 6 from === to >=
    ...(activeStep >= 2 && {
      primaryskl: Yup.array()
        .required('Please select primary skill')
        .min(1, 'Please select primary skill'),
      candQal: Yup.object().required('Highest qualification is required'),
      relexp: Yup.number()
        .typeError('Relevant Experience is required')
        .min(0, 'Experience cannot be negative')
        .max(Yup.ref('expinyrs'), '"Relevant Experience" cannot exceed total Experience')
        .required('Relevant Experience is required'),

      hasresigned: Yup.string().oneOf(['true', 'false']),

      resigneddate: Yup.date()
        .nullable()
        .typeError('Resignation date must be a valid date')
        .when('hasresigned', {
          is: 'true',
          then: (schema) => schema.required('Resignation date is required'),
          otherwise: (schema) => schema.nullable().notRequired(),
        }),

      canjoinby: Yup.date()
        .nullable()
        .typeError('Join by date must be a valid date')
        .when(['hasresigned', 'resigneddate'], {
          is: (hasresigned, resigneddate) =>
            hasresigned === 'true' && resigneddate != null && activeStep === 2,
          then: (schema) =>
            schema.min(
              Yup.ref('resigneddate'),
              '"Joining Date" should be greater than "Resignation Date"'
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    // resumeUpload: Yup.mixed().when(currentCand !== null).required('Resume is required'),
    ...(activeStep >= 5 && {
      candExp: Yup.array()
        .of(
          Yup.object().shape({
            compNm: Yup.string()
              .required('Employer name is required (e.g., "Infosys", "Wipro")')
              .max(100, 'Employer name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Employer name cannot be only blank spaces or start/end with blank spaces (e.g., "  Infosys")',
                (value) => value.trim() !== '' && value === value.trim()
              ),

            designation: Yup.object().required('Designation is required'),

            expfromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date')
              .test('no-future-date', 'From date cannot be a future date', (value) => {
                if (!value) return true;
                const d = new Date(value);
                if (Number.isNaN(d.getTime())) return false;
                return d.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              })
              .test('less-than-to-date', 'From date must be less than To date', (value, context) => {
                if (!value) return true;
                const isCurrentlyWorking =
                  context.parent?.currentywrkng === true ||
                  context.parent?.currentywrkng === 'true';
                if (isCurrentlyWorking) return true;

                const toDate = context.parent?.exptoDate;
                if (!toDate) return true;
                const fromDateObj = new Date(value);
                const toDateObj = new Date(toDate);
                if (Number.isNaN(fromDateObj.getTime()) || Number.isNaN(toDateObj.getTime())) {
                  return true;
                }
                return fromDateObj.setHours(0, 0, 0, 0) < toDateObj.setHours(0, 0, 0, 0);
              }),

            exptoDate: Yup.date()
              .nullable()
              .when('currentywrkng', {
                is: (val) => val === true || val === 'true',
                then: (schema) => schema.nullable().notRequired(),
                otherwise: (schema) =>
                  schema
                    .required('To date is required')
                    .typeError('To date must be a valid date')
                    .test('greater-than-from-date', 'To date must be greater than From date', (value, context) => {
                      if (!value) return true;
                      const fromDate = context.parent?.expfromDate;
                      if (!fromDate) return true;
                      const toDateObj = new Date(value);
                      const fromDateObj = new Date(fromDate);
                      if (Number.isNaN(toDateObj.getTime()) || Number.isNaN(fromDateObj.getTime())) {
                        return true;
                      }
                      return toDateObj.setHours(0, 0, 0, 0) > fromDateObj.setHours(0, 0, 0, 0);
                    })
                    .test('min-date-one-month', 'To Date should be at least 1 month after From Date', (value, context) => {
                      if (!value) return true;
                      const fromDate = context.parent?.expfromDate;
                      if (!fromDate) return true;
                      const toDateObj = new Date(value);
                      const fromDateObj = new Date(fromDate);
                      if (Number.isNaN(toDateObj.getTime()) || Number.isNaN(fromDateObj.getTime())) {
                        return true;
                      }
                      const oneMonthLater = new Date(fromDateObj);
                      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
                      return toDateObj.setHours(0, 0, 0, 0) >= oneMonthLater.setHours(0, 0, 0, 0);
                    })
                    .test('max-today', 'To date cannot be in the future', (value) => {
                      if (!value) return true;
                      const d = new Date(value);
                      if (Number.isNaN(d.getTime())) return true;
                      return d.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
                    }),
              }),
            ctc: Yup.number()
              .min(0, 'CTC should be a positive value.')
              .max(2000000000, 'CTC cannot exceed 2,00,00,00,000')
              .test('phncode-required', 'Currency is required', (value, context) => {
                const { ctccurncy } = context.parent;
                if (value && !ctccurncy) {
                  return false;
                }
                return true;
              }),
          })
        )
        .test(
          'unique-employer-designation',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid

            const seen = new Set();
            const errors = [];

            value.forEach((entry, index) => {
              const company = entry.compNm;
              const desgn = entry.designation?.designationName;

              if (!company || !desgn) return;

              const identifier = `${company}-${desgn}`;

              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });

            if (errors.length) {
              return context.createError({
                path: `candExp[${errors[0]}].compNm`, // Path to the field with the duplicate
                message:
                  'You have already selected this employer and designation in your experience details.',
              });
            }

            return true;
          }
        )
        .test('no-overlapping-dates', function (expArray) {
          if (!expArray || expArray.length < 2) return true;

          const { createError, path } = this;

          const ranges = expArray
            .map((exp, idx) => {
              const from = exp.expfromDate ? new Date(exp.expfromDate).getTime() : null;
              let to = exp.exptoDate ? new Date(exp.exptoDate).getTime() : null;
              if (exp.currentywrkng && !to) {
                to = Infinity;
              }
              if (from === null || to === null) return null;
              return { idx, from, to };
            })
            .filter(Boolean);

          for (let i = 0; i < ranges.length; i += 1) {
            for (let j = i + 1; j < ranges.length; j += 1) {
              const r1 = ranges[i];
              const r2 = ranges[j];

              if (r1.from <= r2.to && r2.from <= r1.to) {
                // Attach error to the first overlapping experience's from date path
                return createError({
                  path: `candExp[${r1.idx}].expfromDate`,
                  message: 'This experience overlaps with another experience date range.',
                });
              }
            }
          }

          return true; // No overlaps
        }),
    }),
    ...(activeStep >= 3 && {
      candEdu: Yup.array()
        .of(
          Yup.object().shape({
            university: Yup.object().required('University is required'),
            qualtype: Yup.object().required('Qualification type is required'),
            qualification: Yup.object().required('Qualification is required'),
            stream: Yup.object().required('Qualification Stream is required'),
            candpercnt: Yup.number()
              .nullable()
              .typeError('Percentage must be a valid number')
              .min(0, 'Percentage cannot be less than 0%')
              .max(100, 'Percentage cannot be greater than 100%')
              .required('Percentage is required') // Make sure the field is required
              .test(
                'max-2-decimals',
                'Enter percentage with a maximum of 2 decimal places (e.g., 89.75)',
                (value) => {
                  if (value === null || value === undefined) return true;
                  const decimalPart = value.toString().split('.')[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              )
              .test(
                'at-least-one',
                'Either percentage or CGPA is required',
                (value, context) => value !== 0.0 || context.parent.candcgpa !== 0.0
              ),
            candcgpa: Yup.number()
              .nullable()
              .min(0, 'CGPA cannot be less than 0')
              .max(10, 'CGPA cannot be greater than 10')
              .test(
                'max-2-decimals',
                'Enter CGPA with a maximum of 2 decimal places (e.g., 8.25)',
                (value) => value === null || /^\d+(\.\d{1,2})?$/.test(value.toString())
              )
              .test(
                'at-least-one',
                'Either percentage or CGPA is required',
                (value, context) => value !== 0.0 || context.parent.candpercnt !== 0.0
              ),
            edufromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date'),

            edutoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date') // Ensures it's a valid date
              .when('currentypurs', {
                is: (val) => val === true || val === 'true',
                then: (schema) => schema.nullable().notRequired(), // Skip validation when pursuing
                otherwise: () =>
                  Yup.date()
                    .required('To date is required') // Make "To Date" required when not pursuing
                    .min(Yup.ref('edufromDate'), '"To Date" should be after "From Date"') // Ensure "To Date" is after "From Date"
                    .test(
                      'min-date-one-year',
                      '"To Date" should be at least 1 year greater than "From Date"',
                      function (value) {
                        if (!value) return true;
                        // eslint-disable-next-line react/no-this-in-sfc
                        const fromDate = this.parent.edufromDate; // Get "edufromDate" from parent context

                        // If either From Date or To Date is missing, return true (skip validation)
                        if (!fromDate || !value) return true;

                        // Convert to Date objects
                        const from = new Date(fromDate);
                        const to = new Date(value);

                        // Validate that To Date is at least 1 year after From Date
                        const oneYearLater = new Date(from.setFullYear(from.getFullYear() + 1));

                        return to >= oneYearLater; // Ensure To Date is at least 1 year greater than From Date
                      }
                    ),
              }),
          })
        )
        // Duplicate Qualification Type + Qualification + Stream check
        .test(
          'unique-qualification-details',
          null,
          (value, context) => {
            if (!value || value.length === 0) return true;

            const seen = new Set();

            for (let index = 0; index < value.length; index += 1) {
              const education = value[index];

              const qualificationTypeId = education.qualtype?.masterId;
              const qualificationId = education.qualification?.masterId;
              const streamId = education.stream?.masterId;

              // Skip until all three values selected
              if (!qualificationTypeId || !qualificationId || !streamId) {
                // eslint-disable-next-line no-continue
                continue;
              }

              // University is ignored here intentionally
              const combinationKey = `${qualificationTypeId}-${qualificationId}-${streamId}`;

              if (seen.has(combinationKey)) {
                return context.createError({
                  path: `candEdu[${index}].qualification`,
                  message:
                    'Same Qualification Type, Qualification and Qualification Stream cannot be added multiple times.',
                });
              }

              seen.add(combinationKey);
            }

            return true;
          }
        )
        // Currently pursuing maximum 2 validation
        .test(
          'max-currently-pursuing',
          null,
          (value, context) => {
            if (!value || value.length === 0) return true;

            const pursuingIndexes = value
              .map((education, index) =>
                education.currentypurs === true ? index : null
              )
              .filter((index) => index !== null);

            if (pursuingIndexes.length > 2) {
              return context.createError({
                path: `candEdu[${pursuingIndexes[2]}].currentypurs`,
                message:
                  'Maximum 2 education details can be marked as Currently Pursuing.',
              });
            }

            return true;
          }
        ),
    }),
    ...(activeStep >= 4 && {
      candCert: Yup.array()
        .of(
          Yup.object().shape({
            certiNm: Yup.string()
              .required('Certification name is required')
              .max(100, 'Certification name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Certification name cannot be only blank spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            certiInstiNm: Yup.string()
              .max(100, 'Certificate institute name must not exceed 100 characters')
              .test(
                'no-spaces-mid',
                'Certificate institute name cannot be only blank spaces or start/end with blank spaces',
                (value) => {
                  if (!value) return true;
                  return value.trim() !== '' && value === value.trim();
                }
              ),
            certfromDate: Yup.date().nullable().typeError('From date must be a valid date'),
            certtoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date')
              .min(Yup.ref('certfromDate'), '"To Date" should be greater than "From Date"'),
          })
        )
        .test(
          'unique-certification',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid

            const seen = new Set();
            const errors = [];

            value.forEach((entry, index) => {
              const certTitle = entry.certiNm;
              const instituteTitle = entry.certiInstiNm;

              if (!certTitle || !instituteTitle) return;

              const identifier = `${certTitle}-${instituteTitle}`;

              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });

            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `candCert[${errors[0]}].certiNm`, // Point to the first duplicate found
                message:
                  'You have already selected this certification and institute in your certification details.',
              });
            }

            return true;
          }
        ),
    }),
    ...(activeStep >= 6 && {
      candRef: Yup.array()
        .of(
          Yup.object().shape({
            refNm: Yup.string()
              .required('Reference name is required (e.g., "Rajesh Sahani")')
              .max(100, 'Reference name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Reference name cannot be only blank spaces or start/end with blank spaces (e.g., "  Rajesh Sahani")',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(
                /^[^\d]*$/,
                'Reference name cannot contain numbers (e.g., "123Rajesh Sahani" is wrong)'
              ),
            refOrgNm: Yup.string()
              .required('Reference employer is required (e.g., "TCS", "Infosys")')
              .max(
                100,
                'Reference employer must not exceed 100 characters (e.g., "HCL Technologies")'
              )
              .test(
                'no-spaces',
                'Reference employer cannot be only blank spaces or start/end with blank spaces (e.g., " Wipro")',
                (value) => value.trim() !== '' && value === value.trim()
              ),

            refdesig: Yup.object().required(
              'Reference designation is required (e.g., "Software Engineer", "Manager")'
            ),

            refEmail: Yup.string()
              .required('Reference email is required (e.g., "example@gmail.com")')
              .max(
                100,
                'Reference email must not exceed 100 characters (e.g., "firstname.lastname@company.com")'
              )
              .matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                'Email must be a valid email address (e.g., "john.doe@gmail.com")'
              ),
            refContact: Yup.string().test(
              'is-valid-length',
              'Enter valid mobile number',
              (value) => {
                if (!value) return true; // If the field is empty, don't validate
                return value.length >= 10 && value.length <= 12;
              }
            ),
          })
        )
        .test(
          'unique-reference',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid

            const seen = new Set();
            const errors = [];

            value.forEach((entry, index) => {
              const refNm = entry.refNm;
              const refOrg = entry.refOrgNm;

              if (!refNm || !refOrg) return;

              const identifier = `${refNm}-${refOrg}`;

              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });

            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `candRef[${errors[0]}].refNm`, // Point to the first duplicate found
                message: 'You have already added this reference in your reference details.',
              });
            }

            return true;
          }
        ),
    }),
    // not required
    expinyrs: Yup.number()
      .max(100, 'Experience cannot more than 100 years')
      .min(0, 'Experience cannot be in negetive'),
    noticeprd: Yup.number()
      .max(365, 'Notice period cannot be more than 365 days.')
      .min(0, 'Notice period cannot be in negetive'),
    currentsal: Yup.number()
      .max(2000000000, 'Current salary cannot be more then 2000000000')
      .min(0, 'Current salary cannot be in negetive')
      .test('phncode-required', 'Currency is required', (value, context) => {
        const { currentsalcurncy } = context.parent;
        if (value && !currentsalcurncy) {
          return false;
        }
        return true;
      }),
    exptsal: Yup.number()
      .max(2000000000, 'Expected salary cannot be more then 2000000000')
      .min(0, 'Expected salary cannot be in negetive')
      .test('phncode-required', 'Currency is required', (value, context) => {
        const { exptsalcurncy } = context.parent;
        if (value && !exptsalcurncy) {
          return false;
        }
        return true;
      }),
  });

  const dynamicSchema = currentCand
    ? baseSchema.concat(
      Yup.object().shape({
        email: Yup.string()
          .required('Email is required')
          .max(100, 'Email must not exceed 100 characters')
          .matches(
            /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
            'Email must be a valid format (e.g., user@example.com)'
          )
          .test('unique', 'Email already exists', async (value) => {
            if (currentCand?.email === value) {
              return true; // Email hasn't changed, so it's valid
            }
            const filteredEmails = candEmailArr.filter(
              (email) => email !== decryptData(currentCand?.email)
            );
            return !filteredEmails.includes(value); // Check for duplicates
          }),

        uniqueNum: Yup.string(),

        uniqueno: Yup.string().when('uniqueNum', ([uniqueNum], schema) => {
          if (uniqueNum === 'AADHAR') {
            return (
              Yup.string()
                .required('Aadhaar number is required')
                .matches(
                  /^[2-9]{1}[0-9]{11}$/,
                  'Invalid Aadhaar number. It must be a 12-digit number. Example: 234567890123'
                )
                // eslint-disable-next-line prefer-arrow-callback
                .test('uniqueNo', 'Unique Identity Document Number already exists', (value) => {
                  if (!value) return true;

                  if (currentCand) return true;

                  if (currentCand && value === currentCand.panNo) {
                    return true;
                  }

                  const filtered = candUniqNoArr.filter((num) => num !== currentCand?.panNo);

                  return !filtered.includes(value);
                })
            );
          }

          if (uniqueNum === 'PAN') {
            return (
              Yup.string()
                .required('PAN number is required')
                .matches(
                  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  'Invalid PAN number format. It must be 10 characters like ABCDE1234F'
                )
                // eslint-disable-next-line prefer-arrow-callback
                .test('uniqueNo', 'Candidate already exists', async (value) => {
                  if (currentCand && value === decryptData(currentCand.panNo)) {
                    return true;
                  }

                  const filtered = candUniqNoArr.filter((num) => num !== currentCand?.panNo);

                  return !filtered.includes(value);
                })
            );
          }

          return schema.notRequired();
        }),
      })
    )
    : baseSchema.concat(
      Yup.object().shape({
        resumeUpload: Yup.mixed()
          .nullable()
          .notRequired()
          .test('resume-required', 'Resume is required', function (value) {
            // eslint-disable-next-line react/no-this-in-sfc
            const { currentCand } = this.options.context || {};

            if (currentCand?.resume && !value) {
              return true;
            }

            return !!value;
          }),
        positionName: Yup.object().nullable().test(
          'is-position-required',
          'position applied for is required',
          (value, testContext) => {
            const { currentCand } = testContext.options.context || {};
            if (currentCand?.isImportedEmployee || currentCand?.status === 'Joined') {
              return true;
            }
            return !!value;
          }
        ),
        srcofhire: Yup.object().required('Source of hire is required'),
        uniqueno: Yup.string().when('uniqueNum', ([uniqueNum], schema) => {
          if (uniqueNum === 'AADHAR') {
            return (
              Yup.string()
                .required('Aadhaar number is required')
                .matches(
                  /^[0-9]{12}$/,
                  'Invalid Aadhaar number. It must be a 12-digit number. Example: 234567890123'
                )
                // eslint-disable-next-line prefer-arrow-callback
                .test('uniqueNo', 'Candidate already exists', async (value) => {
                  if (currentCand) return true;

                  const filtered = candUniqNoArr.filter((num) => num !== currentCand?.panNo);

                  return !filtered.includes(value);
                })
            );
          }

          if (uniqueNum === 'PAN') {
            return (
              Yup.string()
                .required('PAN number is required')
                .matches(
                  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  'Invalid PAN number format. It must be 10 characters like ABCDE1234F'
                )
                // eslint-disable-next-line prefer-arrow-callback
                .test('uniqueNo', 'Candidate already exists', async (value) => {
                  if (currentCand && value === decryptData(currentCand.panNo)) {
                    return true;
                  }

                  const filtered = candUniqNoArr.filter((num) => num !== currentCand?.panNo);

                  return !filtered.includes(value);
                })
            );
          }

          return schema.notRequired();
        }),
      })
    );

  const NewCandidateSchema = dynamicSchema;

  const getPrefLoc = useCallback(() => {
    if (currentCandPrefLoc) {
      const mappedPrefLoc = currentCandPrefLoc.map((loc) => ({
        cityId: loc.candPrefLocId,
        cityName: loc.prefLocCityName,
      }));
      setCPrefLoc(mappedPrefLoc);
    }
  }, [currentCandPrefLoc]);

  const toggleContent = useCallback(() => {
    if (currentCand) {
      setEditResume(true);
      if (currentCand && currentCand.resume) {
        setEditResume(true);
        setResumeTyp(currentCand.resume.split('.').pop().toLowerCase());
      } else {
        setResumeTyp('');
      }
    }
  }, [currentCand]);

  const getSkl = useCallback(() => {
    if (currentCandSkils) {
      const ps = currentCandSkils.filter((item) => item.skillType === 'Primary');
      const prmS = ps.map((p) => p.skill);
      setCPSkl(prmS);
      const ss = currentCandSkils.filter((item) => item.skillType === 'Secondary');
      const secS = ss.map((p) => p.skill);
      setCSSkl(secS);
      setSecSkillArr(secS);
    }
  }, [currentCandSkils]);

  const getEduDtl = useCallback(() => {
    if (currentCandEduDtl) {
      const e = currentCandEduDtl.map((cEdu) => ({
        eduSrno: cEdu.candidateEducationDetailsId,
        university: cEdu.university,
        othrUni: cEdu.universityName,
        qualtype: cEdu.qualificationType,
        qualification: cEdu.qualification,
        stream: cEdu.stream,
        candpercnt: cEdu.candidateQualPercentage,
        candcgpa: cEdu.candidateQualCgpa,
        currentypurs: cEdu.currentlyPursuing,
        edufromDate: cEdu.candidateQualFromDate ? new Date(cEdu.candidateQualFromDate) : null,
        edutoDate: cEdu.candidateQualToDate ? new Date(cEdu.candidateQualToDate) : null,
      }));
      setCEduDtl(e);
    }
  }, [currentCandEduDtl]);

  const getExpDtl = useCallback(() => {
    if (currentCandExpDtl) {
      const e = currentCandExpDtl.map((cExp) => ({
        expSrno: cExp.candidateExperienceDetailsId,
        compNm: cExp.candidateExperienceCompanyName,
        designation: cExp.candidateDesignation,
        ctc: decryptData(cExp.candidateCtc) || cExp.candidateCtc || 0,
        ctccurncy: cExp.candidateCtcCurrency,
        country: cExp.candidateExperienceCountryid,
        currentywrkng: Boolean(
          cExp.candidateCurrentlyWorking ?? cExp.isCandidateCurrentlyWorking ?? false
        ),
        expfromDate: cExp.candidateExperienceFromDate
          ? new Date(cExp.candidateExperienceFromDate)
          : null,
        exptoDate: cExp.candidateExperienceToDate ? new Date(cExp.candidateExperienceToDate) : null,
      }));
      setCExpDtl(e);
      if (e.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: true,
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: false,
        }));
      }
    }
  }, [currentCandExpDtl]);

  const getCertDtl = useCallback(() => {
    if (currentCandCertDtl) {
      const e = currentCandCertDtl.map((cCrt) => ({
        cerSrno: cCrt.candidateCertificationId,
        certiNm: cCrt.certificationName,
        certiInstiNm: cCrt.instituteName,
        certfromDate: cCrt.durationFrom ? new Date(cCrt.durationFrom) : null,
        certtoDate: cCrt.durationTo ? new Date(cCrt.durationTo) : null,
      }));
      setCCertDtl(e);
    }
  }, [currentCandCertDtl]);

  const getRefDtl = useCallback(() => {
    if (currentCandRefDtl) {
      const e = currentCandRefDtl.map((cRef) => ({
        refSrno: cRef.candidateReferenceId,
        refNm: decryptData(cRef.candidateReferenceName),
        refOrgNm: decryptData(cRef.candidateReferenceOrganizationName),
        refdesig: cRef.candidateReferenceDesignation,
        refEmail: decryptData(cRef.candidateReferenceEmail),
        refContact: decryptData(cRef.candidateReferenceContactNumber),
      }));
      setCRefDtl(e);
    }
  }, [currentCandRefDtl]);

  useEffect(() => {
    toggleContent();
    getPrefLoc();
    getEduDtl();
    getSkl();
    getExpDtl();
    getCertDtl();
    getRefDtl();
  }, [
    currentCand,
    toggleContent,
    currentCandPrefLoc,
    getPrefLoc,
    currentCandEduDtl,
    getEduDtl,
    currentCandSkils,
    getSkl,
    currentCandExpDtl,
    getExpDtl,
    currentCandCertDtl,
    getCertDtl,
    currentCandRefDtl,
    getRefDtl,
  ]);

  // Step 1 — fetch presigned URL when candidate loads
  useEffect(() => {
    const loadProfilePhoto = async () => {
      const directUrl =
        currentCand?.profilePhotoUrl ||
        (typeof currentCand?.profilePhoto === 'string' &&
          (currentCand.profilePhoto.startsWith('http://') ||
            currentCand.profilePhoto.startsWith('https://') ||
            currentCand.profilePhoto.startsWith('data:'))
          ? currentCand.profilePhoto
          : null);

      if (directUrl) {
        setProfilePhotoUrl(directUrl);
        return;
      }

      const objectKey = currentCand?.profilePhoto;

      if (!objectKey || objectKey.startsWith('/api/files/')) {
        setProfilePhotoUrl(null);
        return;
      }

      if (typeof objectKey === 'string' && objectKey.startsWith('/assets/')) {
        const base = (axiosInstance.defaults.baseURL || '').replace(/\/$/, '').replace(/\/api.*$/, '');
        setProfilePhotoUrl(`${base}${objectKey}`);
        return;
      }

      try {
        const { data } = await axiosInstance.get(
          '/rest/candidate/profile-photo',
          {
            params: { objectKey },
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setProfilePhotoUrl(data.photoUrl || null);
      } catch (err) {
        console.error('Failed to load profile photo:', err);
        setProfilePhotoUrl(null);
      }
    };

    loadProfilePhoto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCand?.profilePhoto, currentCand?.profilePhotoUrl]);

  // Step 2 — reset form AFTER presigned URL is ready
  useEffect(() => {
    if (profilePhotoUrl) {
      setValue('avatarUrl', profilePhotoUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profilePhotoUrl]);

  const [srcOfHrArr, setSrcOfHrArr] = useState([]);
  const [genderArr, setGenderArr] = useState([]);
  const [desgntnArr, setDesgntnArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [cityArr, setCityArr] = useState([]);
  const [qualArr, setQualArr] = useState([]);
  const [nmTitleArr, setNmTitleArr] = useState([]);
  const [universityArr, setUniversityArr] = useState([]);
  const [qualTypeArr, setQualTypeArr] = useState([]);
  const [certNmArr, setCertNmArr] = useState([]);
  const [certInstNmArr, setCertInstNmArr] = useState([]);
  const [streamArr, setStreamArr] = useState([]);
  const [skillArr, setSkillArr] = useState([]);
  const [secSkillArr, setSecSkillArr] = useState([]);
  const [priSkillArr, setPriSkillArr] = useState([]);
  const [uniqueNumber, setUniqueNumber] = useState('');
  const uniqueNum = ['AADHAR', 'PAN'];

  const yesNoArr = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  const isJoinedCandidate = Boolean(
    currentCand?.employee != null ||
    Boolean(currentCand?.employeeId) ||
    Boolean(currentCand?.employeeCode) ||
    Boolean(currentCand?.empId) ||
    String(currentCand?.candStatus || '').toLowerCase().trim() === 'joined' ||
    String(currentCand?.status || '').toLowerCase().trim() === 'joined' ||
    String(currentCand?.candidateStatus || '').toLowerCase().trim() === 'joined' ||
    String(currentCand?.joiningStatus || '').toLowerCase().trim() === 'joined' ||
    String(currentCand?.offerStatus || '').toLowerCase().trim() === 'joined' ||
    currentCand?.isJoined === true
  );

  const truncateFileName = (fileName, maxLength) => {
    if (fileName.length <= maxLength) return fileName;
    const start = fileName.substring(0, maxLength / 2);
    const end = fileName.substring(fileName.length - maxLength / 2);
    return `${start}...${end}`;
  };

  useEffect(() => {
    axiosInstance
      .get(`/rest/candidate/external/open-positions`)
      .then((res) => {
        const data = res.data;

        let uniquePositions = data.filter(
          (pos, index, self) =>
            index === self.findIndex((p) => p.candidateRequisitionId === pos.candidateRequisitionId)
        );

        // Fallback for closed/cancelled/joined requisition
        if (currentCand?.candidateRequisitionId || currentCand?.positionName) {
          const exists = uniquePositions.some(
            (p) =>
              (currentCand?.candidateRequisitionId && p.candidateRequisitionId === currentCand.candidateRequisitionId) ||
              (currentCand?.positionName && p.positionName === currentCand.positionName)
          );

          if (!exists) {
            const historicalPos = {
              candidateRequisitionId: currentCand?.candidateRequisitionId || 0,
              positionName: currentCand?.positionName || 'Applied Position',
              experienceFrom: currentCand?.experienceFrom || 0,
              experienceTo: currentCand?.experienceTo || 0,
              isClosedOrHistorical: true,
            };
            uniquePositions = [historicalPos, ...uniquePositions];
          }
        }

        setOpenPositionsArr(uniquePositions);

        // Auto-select position from URL reqId if not selected
        const searchParams = new URLSearchParams(window.location.search);
        const reqIdParam = searchParams.get('reqId') || sessionStorage.getItem('vendorReqId');
        if (reqIdParam && !getValues('positionName')) {
          let cleanReqId = reqIdParam;
          try {
            const dec = decryptData(reqIdParam) || decryptData(decodeURIComponent(reqIdParam));
            if (dec) cleanReqId = dec;
          } catch (e) {
            // ignore
          }
          const matched = uniquePositions.find(
            (p) => String(p.candidateRequisitionId) === String(cleanReqId)
          );
          if (matched) {
            setValue('positionName', matched, { shouldValidate: true });
          }
        }
      })
      .catch((err) => console.error('Failed to fetch open positions', err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCand]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const tagEmailParam = searchParams.get('tagEmail');
    if (tagEmailParam) {
      let cleanTagEmail = tagEmailParam;
      try {
        const decodedEmail = decodeURIComponent(tagEmailParam);
        const decrypted = decryptData(tagEmailParam) || decryptData(decodedEmail);
        if (decrypted) {
          cleanTagEmail = decrypted;
        } else if (decodedEmail) {
          cleanTagEmail = decodedEmail;
        }
      } catch (e) {
        // already plain email
      }
      if (cleanTagEmail) {
        setTagEmail(cleanTagEmail);
        localStorage.setItem('tagEmail', cleanTagEmail);
      }
    } else {
      const localEmail = localStorage.getItem('tagEmail');
      if (localEmail) {
        setTagEmail(localEmail);
      }
    }

    const reqIdParam = searchParams.get('reqId');
    const vendorIdParam = searchParams.get('vendorId');
    const isVendorRoute = window.location.pathname.includes('vendorCandidateForm') || Boolean(vendorIdParam);

    if (isVendorRoute) {
      sessionStorage.setItem('isVendorCandidateForm', 'true');
      if (vendorIdParam) sessionStorage.setItem('vendorParamId', vendorIdParam);
      if (reqIdParam) sessionStorage.setItem('vendorReqId', reqIdParam);
    }
  }, []);

  const handleFetchedData = () => {
    const fetchMasterData = axiosInstance.get(`/rest/candidate/external/fetchMastersData`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const fetchValidationData = axiosInstance.get(
      `/rest/candidate/external/fetchCandValidtionData`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Call both APIs in parallel
    Promise.all([fetchMasterData, fetchValidationData])
      .then(([masterDataRes, validationDataRes]) => {
        const masterData = masterDataRes.data;
        const validationData = validationDataRes.data;

        setSrcOfHrArr(masterData.scrOfhireData || []);

        const isVendorForm = window.location.pathname.includes('vendorCandidateForm')
          || Boolean(new URLSearchParams(window.location.search).get('vendorId'))
          || sessionStorage.getItem('isVendorCandidateForm') === 'true';

        if (isVendorForm && masterData.scrOfhireData) {
          const vendorOption = masterData.scrOfhireData.find(
            (s) => s.sourceOfHire?.toLowerCase().includes('vendor') || s.sourceOfHireId === 3
          ) || masterData.scrOfhireData[0];

          if (vendorOption && !getValues('srcofhire')) {
            setValue('srcofhire', vendorOption, { shouldValidate: true });
          }

          const searchParams = new URLSearchParams(window.location.search);
          const reqIdParam = searchParams.get('reqId') || sessionStorage.getItem('vendorReqId');
          const vendorIdParam = searchParams.get('vendorId') || sessionStorage.getItem('vendorParamId');

          if (reqIdParam || vendorIdParam) {
            axiosInstance
              .get('/rest/vendor-portal/candidates/external/requisition-info', {
                params: {
                  reqId: reqIdParam || undefined,
                  vendorId: vendorIdParam || undefined,
                },
              })
              .then((res) => {
                if (res.data?.vendorName) {
                  sessionStorage.setItem('vendorOrgName', res.data.vendorName);
                  if (res.data?.vendorId) {
                    sessionStorage.setItem('vendorEntityId', String(res.data.vendorId));
                  }
                  setValue('srcofhireNm', res.data.vendorName, { shouldValidate: true });
                } else if (!getValues('srcofhireNm')) {
                  setValue('srcofhireNm', 'Vendor', { shouldValidate: true });
                }

                if (res.data?.candidateRequisitionId && !getValues('positionName')) {
                  setValue(
                    'positionName',
                    {
                      candidateRequisitionId: res.data.candidateRequisitionId,
                      positionName: res.data.positionName,
                      jobCode: res.data.jobCode,
                    },
                    { shouldValidate: true }
                  );
                }
              })
              .catch(() => {
                if (!getValues('srcofhireNm')) {
                  setValue('srcofhireNm', 'Vendor Sourced', { shouldValidate: true });
                }
              });
          } else if (!getValues('srcofhireNm')) {
            setValue('srcofhireNm', 'Vendor Sourced', { shouldValidate: true });
          }
        }
        setGenderArr(masterData.genderData || []);
        setSkillArr(masterData.skillData || []);
        setDesgntnArr(
          masterData.desginationData
            ? [...masterData.desginationData].sort((a, b) =>
              (a.masterName || '').localeCompare(b.masterName || '')
            )
            : []
        );
        setQualArr(masterData.qualData || []);
        setNmTitleArr(masterData.nmTitleData || []);
        setCountryArr(
          masterData.countriesData
            ? [...masterData.countriesData].sort((a, b) =>
              (a.countryName || '').localeCompare(b.countryName || '')
            )
            : []
        );
        setCityArr(masterData.citiesData || []);
        setUniversityArr(masterData.universityData || []);
        setQualTypeArr(masterData.qualTypData || []);
        setStreamArr(masterData.streamData || []);

        const sortedCertNmArr = masterData.certNm
          ? [...masterData.certNm].sort((a, b) => a.localeCompare(b))
          : [];
        const sortedCertInstNmArr = masterData.certInst
          ? [...masterData.certInst].sort((a, b) => a.localeCompare(b))
          : [];

        setCertNmArr(sortedCertNmArr);
        setCertInstNmArr(sortedCertInstNmArr);

        if (validationData?.candEmails) {
          const decryptedEmails = validationData.candEmails.map(decryptData);
          setCandEmailArr(decryptedEmails);
        }
        if (validationData?.candUnqNo) {
          const decryptedPanNos = validationData.candUnqNo.map(decryptData);
          setCandUniqNoArr(decryptedPanNos);
        }

        if (masterData.nmTitleData && !getValues('nameTitle')) {
          const defaultTitle =
            masterData.nmTitleData.find(
              (item) => item.masterName === 'Mr.' || item.salutationName === 'Mr.' || item.nameTitleName === 'Mr.'
            ) || masterData.nmTitleData[0];
          if (defaultTitle) {
            setValue('nameTitle', defaultTitle, { shouldValidate: true });
          }
        }

        const cur = subscr?.country;
        if (cur) {
          if (!getValues('currentsalcurncy')) {
            const countryCurrency = masterData.countriesData?.find(
              (item) => item.currencySymbol === cur.currencySymbol
            );
            setValue('currentsalcurncy', countryCurrency || cur, { shouldValidate: true });
          }

          if (!getValues('exptsalcurncy')) {
            const countryCurrency = masterData.countriesData?.find(
              (item) => item.currencySymbol === cur.currencySymbol
            );
            setValue('exptsalcurncy', countryCurrency || cur, { shouldValidate: true });
          }

          const defaultCountryPhone = masterData.countriesData?.find(
            (item) => item.phoneCode === '91' || item.countryName === 'India'
          );
          if (!getValues('phncode') || !currentCand?.mobPhoneCode) {
            setValue('phncode', defaultCountryPhone || cur, { shouldValidate: true });
          }

          setValue('curr', cur, { shouldValidate: true });
        }
      })
      .catch((err) => {
        console.error(err);
        handleApiError(err);
      });
  };

  useEffect(() => {
    handleFetchedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const candidateEmailFromUrl = useMemo(() => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const emailParam = searchParams.get('email');
      if (emailParam) {
        const decoded = decodeURIComponent(emailParam);
        const decrypted = decryptData(emailParam) || decryptData(decoded);
        if (decrypted && decrypted.includes('@')) return decrypted;
        if (decoded && decoded.includes('@')) return decoded;
        if (emailParam.includes('@')) return emailParam;
      }
    } catch (e) {
      // ignore
    }
    return '';
  }, []);

  const decryptedEmail = currentCand ? decryptData(currentCand.email) : (candidateEmailFromUrl || '');
  const decryptedPanNo = currentCand ? decryptData(currentCand.panNo) : '';
  const decryptedMobileNo = currentCand ? decryptData(currentCand.mobileNumber) : '';

  const safeDate = (val) => {
    if (!val) return null;

    if (val instanceof Date) {
      return isValid(val) ? val : null;
    }

    const isoString = val.replace(' ', 'T').replace(/\.(\d{2})\+00$/, '.$1Z');
    const d = parseISO(isoString);

    return isValid(d) ? d : null;
  };

  const defaultValues = useMemo(
    () => ({
      avatarUrl: isProfilePhotoRemoved
        ? null
        : (currentCand?.profilePhotoUrl ||
          profilePhotoUrl ||
          (typeof currentCand?.profilePhoto === 'string' &&
            (currentCand.profilePhoto.startsWith('http://') ||
              currentCand.profilePhoto.startsWith('https://') ||
              currentCand.profilePhoto.startsWith('data:'))
            ? currentCand.profilePhoto
            : null)),
      resumeUpload: null,
      srcofhire: currentCand?.sourceOfHire || null,
      positionName:
        openPositionsArr.find(
          (option) =>
            (currentCand?.candidateRequisitionId && option.candidateRequisitionId === currentCand.candidateRequisitionId) ||
            (currentCand?.positionName && option.positionName?.includes(currentCand.positionName))
        ) ||
        (currentCand?.candidateRequisitionId || currentCand?.positionName
          ? {
            candidateRequisitionId: currentCand?.candidateRequisitionId || 0,
            positionName: currentCand?.positionName || 'Applied Position',
            experienceFrom: currentCand?.experienceFrom || 0,
            experienceTo: currentCand?.experienceTo || 0,
            isClosedOrHistorical: true,
          }
          : null),
      srcofhireNm: currentCand?.sourceOfHireName || '',
      fname: currentCand?.firstName || '',
      nameTitle: currentCand?.nameTitle || null,
      mname: currentCand?.middleName || '',
      lname: currentCand?.lastName || '',
      email: decryptedEmail || '',
      mobno: decryptedMobileNo || '',
      phncode: currentCand?.mobPhoneCode || null,
      gender: currentCand?.gender || null,
      cuurntloc: currentCand?.currentLocationCity || null,
      prefloc: currentCandPrefLoc ? cPrefLoc : [],
      readytolocate: currentCand?.readyToRelocate || false,
      panno: currentCand?.panNo || '',
      linkedinUrl: currentCand?.linkedinUrl || '',
      expinyrs: currentCand?.experienceInYears || 0.0,
      relexp: currentCand?.relevantExperience || 0.0,
      candQal: currentCand?.qualification || null,
      currentjob: currentCand?.currentJobTitle || null,
      currentcomp: currentCand?.currentEmployer || '',
      noticeprd: currentCand?.noticePeriod || 0,
      currentsal: currentCand?.currentSalary || 0,
      currentsalcurncy: currentCand?.currentSalaryCurrency || null,
      exptsal: currentCand?.expectedSalary || 0,
      exptsalcurncy: currentCand?.expectedSalaryCurrency || null,
      primaryskl: currentCandSkils ? cPskl : [],
      secondskl: currentCandSkils ? cSskl : [],
      hasresigned: currentCand?.hasResigned || false,
      iscurrentemp: currentCand?.currentEmployee || false,
      uniqueNum: currentCand?.uniqueNoType || '',
      uniqueno: decryptedPanNo || '',

      resigneddate: safeDate(currentCand?.resignDate),
      canjoinby: safeDate(currentCand?.canJoinBy),

      candExp:
        cExpDtl && cExpDtl.length > 0
          ? cExpDtl
          : currentCandExpDtl && currentCandExpDtl.length > 0
          ? currentCandExpDtl.map((cExp) => ({
              expSrno: cExp.candidateExperienceDetailsId,
              compNm: cExp.candidateExperienceCompanyName,
              designation: cExp.candidateDesignation,
              ctc: decryptData(cExp.candidateCtc) || cExp.candidateCtc || 0,
              ctccurncy: cExp.candidateCtcCurrency,
              country: cExp.candidateExperienceCountryid,
              currentywrkng: Boolean(
                cExp.candidateCurrentlyWorking ?? cExp.isCandidateCurrentlyWorking ?? false
              ),
              expfromDate: cExp.candidateExperienceFromDate
                ? new Date(cExp.candidateExperienceFromDate)
                : null,
              exptoDate: cExp.candidateExperienceToDate
                ? new Date(cExp.candidateExperienceToDate)
                : null,
            }))
          : [],

      candCert: currentCandCertDtl ? cCertDtl : [],

      candEdu: currentCandEduDtl ? cEduDtl : [],

      candRef: currentCandRefDtl ? cRefDtl : [],
      lastUpdatedDate: safeDate(new Date()),
      createdDate: safeDate(new Date()),
      startDate: safeDate(new Date()),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      currentCand,
      currentCandPrefLoc,
      cPrefLoc,
      currentCandEduDtl,
      cEduDtl,
      currentCandSkils,
      cPskl,
      cSskl,
      currentCandExpDtl,
      cExpDtl,
      currentCandCertDtl,
      cCertDtl,
      currentCandRefDtl,
      cRefDtl,
      openPositionsArr,
      profilePhotoUrl,
      currentCand?.profilePhotoUrl,
      isProfilePhotoRemoved,
    ]
  );

  // onchange Method
  const methods = useForm({
    resolver: yupResolver(NewCandidateSchema),
    context: { currentCand },
    mode: 'onChange',
    shouldUnregister: false,
    defaultValues,
  });

  const {
    control,
    handleSubmit,
    watch,
    resetField,
    getValues,
    setValue,
    reset,
    formState: { errors },
    trigger,
  } = methods;

  const filterPhoneCode = createFilterOptions({
    stringify: (option) => `${option.countryName} (${option.phoneCode})`,
  });

  const filterCurrency = createFilterOptions({
    stringify: (option) => `${option.countryName} (${option.currencySymbol})`,
  });

  useEffect(
    () => {
      if (currentCand) {
        reset(defaultValues);
        setUniqueNumber(currentCand.uniqueNoType);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentCand, reset, defaultValues]
  );

  useEffect(() => {
    if (cExpDtl && cExpDtl.length > 0) {
      setValue('candExp', cExpDtl);
    }
  }, [cExpDtl, setValue]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const emailParam = searchParams.get('email');
    if (emailParam) {
      let cleanEmail = emailParam;
      try {
        const decodedEmail = decodeURIComponent(emailParam);
        const decrypted = decryptData(emailParam) || decryptData(decodedEmail);
        if (decrypted && decrypted.includes('@')) {
          cleanEmail = decrypted;
        } else if (decodedEmail && decodedEmail.includes('@')) {
          cleanEmail = decodedEmail;
        }
      } catch (e) {
        // already plain email
      }
      if (cleanEmail && !getValues('email')) {
        setValue('email', cleanEmail, { shouldValidate: true });
      }
    }
  }, [getValues, setValue]);

  // Resume Upload
  const handleRemoveResume = useCallback(() => {
    setValue('resumeUpload', null);
    setRFileNm('');
    setResumeTyp('');
    if (currentCand) {
      setEditResume(true);
      setUploadClick(true);
      setResumeTyp(currentCand.resume.split('.').pop().toLowerCase());
    }
  }, [setValue, setRFileNm, currentCand, setEditResume]);

  const handleDropResume = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      setEditResume(false);

      setRFileNm(truncateFileName(file.name, 40));
      setResumeTyp(file.type);

      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      if (!currentCand) {
        setFileToAutoFill(newFile);
        quickAutoFill.onTrue();
      }
      if (newFile) {
        setValue('resumeUpload', newFile, { shouldValidate: true });
      }
    },
    [setValue, setRFileNm, setEditResume, currentCand, quickAutoFill, setFileToAutoFill]
  );

  const handleAutoFillResume = useCallback(async () => {
    const cur = subscr.country;

    setIsResumeProcessing(true);
    const formData = new FormData();
    formData.append('file', fileToAutoFill);
    const parsRsmUrl = `/rest/candidate/external/getResumeTxt`;
    await axiosInstance
      .post(parsRsmUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (!res.data.fetchedCandData) {
          console.info('Resume auto-fill skipped: no data extracted');
          return;
        }

        setValue('fname', res.data.fetchedCandData.fname);
        setValue('lname', res.data.fetchedCandData.lname);
        setValue('email', res.data.fetchedCandData.email);
        setValue('mobno', res.data.fetchedCandData.phone);
        setValue('phncode', res.data.fetchedCandData.phoneCode);

        if (!getValues('phncode')) {
          const phoneCode = cur;
          setValue('phncode', phoneCode, { shouldValidate: true });
        }

        setValue('cuurntloc', res.data.fetchedCandData.currentLocation);
        setValue('linkedinUrl', res.data.fetchedCandData.linkedinUrl);
        setValue('candQal', res.data.fetchedCandData.highestQualification);
        setValue('currentjob', res.data.fetchedCandData.currentDesignation);
        setValue('currentcomp', res.data.fetchedCandData.currentEmployer);
        setValue('primaryskl', res.data.fetchedCandSklData);
        if (res.data.fetchedCandEduData) {
          const e = res.data.fetchedCandEduData.map((cEdu) => ({
            eduSrno: 0,
            university: cEdu.university,
            othrUni: cEdu.otherUni,
            qualtype: cEdu.degreeType,
            qualification: cEdu.degree,
            stream: null,
            candpercnt: cEdu.percentage,
            candcgpa: cEdu.cgpa,
            currentypurs: '',
            edufromDate: cEdu.fromDate ? new Date(cEdu.fromDate) : null,
            edutoDate: cEdu.toDate ? new Date(cEdu.toDate) : null,
          }));
          setValue('candEdu', e);
        }
        if (res.data.fetchedCandExpData) {
          const e = res.data.fetchedCandExpData.map((cExp) => ({
            expSrno: 0,
            compNm: cExp.companyName,
            designation: cExp.designation,
            ctc: 0,
            ctccurncy: null,
            country: null,
            currentywrkng: false,
            expfromDate: cExp.fromDate ? new Date(cExp.fromDate) : null,
            exptoDate: cExp.toDate ? new Date(cExp.toDate) : null,
          }));
          setValue('candExp', e);
          setSwitchState((prevState) => ({
            ...prevState,
            experience: true,
          }));
        }
        trigger();
      })
      .catch((error) => {
        console.error('Error processing file:', error);
        handleApiError(error);
      })
      .finally(() => {
        setIsResumeProcessing(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileToAutoFill, setValue, token]);

  const downloadResume = async (resumePath) => {
    try {
      if (!resumePath) {
        enqueueSnackbar('No resume Found for This Candidate. Please upload new Resume', { variant: 'warning' });
        return;
      }

      const fileType = resumePath.split('.').pop().toLowerCase();
      const fileName = resumePath.split('/').pop();

      const response = await axiosInstance.get(
        `/rest/candidate/external/download-resume?filename=${encodeURIComponent(
          fileName
        )}&fileType=${encodeURIComponent('Resume')}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (fileType === 'pdf') {
        const blobForOpen = new Blob([response.data], { type: response.headers['content-type'] });
        const urlForOpen = window.URL.createObjectURL(blobForOpen);
        window.open(urlForOpen, '_blank');
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `resume.${fileType}`);
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.error(error);
      const msg = error.response?.data?.error
        || error.response?.data?.message
        || 'Resume download failed. Please try again.';
      enqueueSnackbar(msg, { variant: 'error' });
    }
  };

  function getResumeIcon() {
    switch (resumeTyp) {
      case 'pdf':
      case 'application/pdf':
        return <Iconify icon="vscode-icons:file-type-pdf2" color="#00a76f" width={35} />;
      case 'docx':
      case 'doc':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/msword':
        return <Iconify icon="vscode-icons:file-type-word" color="#00a76f" width={35} />;
      default:
        return <Iconify icon="flat-color-icons:document" width={35} />;
    }
  }

  useEffect(() => {
    if (!uploadClick && fileInputRef.current) {
      const input = fileInputRef.current.querySelector('input[type="file"]');
      if (input) {
        input.click();
        const handleFocusBack = () => {
          setTimeout(() => {
            if (!input.files || input.files.length === 0) {
              setUploadClick(true);
            }
          }, 200);
        };

        window.addEventListener('focus', handleFocusBack, { once: true });
      }
    }
  }, [uploadClick]);

  const [isEduProcessed, setIsEduProcessed] = useState(false);
  const [isCertProcessed, setIsCertProcessed] = useState(false);
  const [isRefProcessed, setIsRefProcessed] = useState(false);
  const [isExpProcessed, setIsExpProcessed] = useState(false);
  const [isSkillsProcessed, setIsSkillsProcessed] = useState(false);

  const handleStepChange = (newStep) => {
    if (newStep !== activeStep) {
      setIsEduProcessed(false);
      setIsCertProcessed(false);
      setIsRefProcessed(false);
      setIsExpProcessed(false);
      setIsSkillsProcessed(false);
    }
    setActiveStep(newStep);
  };

  const executeFormSubmission = async (data) => {
    loadingSend.onTrue();

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      loadingSend.onFalse();

      const isVendorSession = window.location.pathname.includes('vendorCandidateForm')
        || Boolean(new URLSearchParams(window.location.search).get('vendorId'))
        || sessionStorage.getItem('isVendorCandidateForm') === 'true';

      let resolvedSourceOfHireName = data.srcofhireNm;
      if (isVendorSession) {
        const storedVendorName = sessionStorage.getItem('vendorOrgName');
        resolvedSourceOfHireName = data.srcofhireNm || storedVendorName || 'Vendor';
      }

      const candData = {
        currentLocationCity: data.cuurntloc,
        gender: data.gender,
        nameTitle: data.nameTitle,
        qualification: data.candQal,
        candidateRequisitionId: data.positionName?.candidateRequisitionId || null,
        positionName: data.positionName?.positionName || null,
        sourceOfHire: data.srcofhire,
        firstName: data.fname,
        middleName: data.mname,
        lastName: data.lname,
        mobileNumber: encryptData(data.mobno),
        mobPhoneCode: data.phncode,
        currentEmployer: data.currentcomp,
        currentJobTitle: data.currentjob,
        currentSalaryCurrency: data.currentsalcurncy,
        currentSalary: Math.round(data.currentsal),
        expectedSalaryCurrency: data.exptsalcurncy,
        expectedSalary: Math.round(data.exptsal),
        readyToRelocate: data.readytolocate,
        panNo: encryptData(data.uniqueno),
        linkedinUrl: data.linkedinUrl,
        relevantExperience: data.relexp,
        noticePeriod: data.noticeprd,
        canJoinBy: data.canjoinby,
        hasResigned: data.hasresigned,
        resignDate: data.resigneddate,
        sourceOfHireName: resolvedSourceOfHireName || 'Direct',
        sourcedByVendor: (sessionStorage.getItem('vendorEntityId') && !Number.isNaN(parseInt(sessionStorage.getItem('vendorEntityId'), 10)))
          ? { vendorId: parseInt(sessionStorage.getItem('vendorEntityId'), 10) }
          : (!Number.isNaN(parseInt(sessionStorage.getItem('vendorParamId'), 10))
            ? { vendorId: parseInt(sessionStorage.getItem('vendorParamId'), 10) }
            : null),
        experienceInYears: data.expinyrs,
        email: encryptData(data.email),
        isFinalCand: data.isFinalStep || isFinalStep,
        currentEmployee: data.iscurrentemp,
        uniqueNoType: data.uniqueNum,
        createdDate: data.createdDate,
        lastUpdatedDate: data.lastUpdatedDate,
        profilePhoto: isProfilePhotoRemoved ? null : (currentCand?.profilePhoto || null),
      };

      if (currentCand && currentCand.candidateId) {
        if (data.resumeUpload) {
          const formData = new FormData();
          formData.append('candD', JSON.stringify(candData));
          formData.append('resumeF', data.resumeUpload);
          formData.append('candId', currentCand.candidateId);
          if (data.avatarUrl instanceof File) {
            formData.append('profileP', data.avatarUrl);
          }

          const updtUrl = `/rest/candidate/external/updtCandRsm`;
          await axiosInstance
            .put(updtUrl, formData, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => { });
        } else {
          const formData = new FormData();
          if (data.avatarUrl instanceof File) {
            formData.append('profileP', data.avatarUrl);
          }
          formData.append('candD', JSON.stringify(candData));

          const updtUrl = `/rest/candidate/external/updtCand/${currentCand.publicId}`;
          await axiosInstance
            .put(updtUrl, formData, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => { });
        }

        if (isProfilePhotoRemoved && !curCandPic) {
          await axiosInstance.delete(
            `/rest/candidate/external/deleteProfile/${currentCand.candidateId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }

        if (activeStep === 3 || activeStep === steps.length - 1) {
          if (currentCandEduDtl || data.candEdu) {
            const addedEdus = data.candEdu.filter((edu) => edu.eduSrno === 0);
            const updtEdus = data.candEdu.filter((edu) => edu.eduSrno !== 0);
            const removeEdus = cEduDtl.filter(
              (currEdu) => !updtEdus.some((edu) => edu.eduSrno === currEdu.eduSrno)
            );

            if (addedEdus.length > 0) {
              addedEdus.forEach(async (cEdu) => {
                const cEduData = {
                  candidateId: currentCand.candidateId,
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  candidateQualPercentage: cEdu.candpercnt,
                  candidateQualCgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  candidateQualFromDate: cEdu.edufromDate,
                  candidateQualToDate: cEdu.edutoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const addCandEduUrl = `/rest/candDetails/external/addCandEdu`;
                await axiosInstance
                  .post(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res4) => {
                    console.log(res4.data);
                  });
              });
            }
            if (removeEdus.length > 0) {
              removeEdus.forEach(async (remove) => {
                if (remove?.eduSrno) {
                  await axiosInstance.delete(
                    `/rest/candDetails/external/deleteEduData/${remove.eduSrno}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                }
              });
            }
            if (updtEdus.length > 0) {
              updtEdus.forEach(async (cEdu) => {
                const cEduData = {
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  candidateQualPercentage: cEdu.candpercnt,
                  candidateQualCgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  candidateQualFromDate: cEdu.edufromDate,
                  candidateQualToDate: cEdu.edutoDate,
                  lastUpdatedDate: new Date(),
                };
                const updtCandEdUrl = `/rest/candDetails/external/updateEduData/${cEdu.eduSrno}`;
                await axiosInstance
                  .put(updtCandEdUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => {
                    console.log('response= ', res5);
                  });
              });
            }
          }
        }

        if (activeStep === 4 || activeStep === steps.length - 1) {
          if (currentCandCertDtl || data.candCert) {
            const addedCerts = data.candCert.filter((cert) => cert.cerSrno === 0);
            const updtCerts = data.candCert.filter((cert) => cert.cerSrno !== 0);
            const removeCerts = cCertDtl.filter(
              (currCrt) => !updtCerts.some((crt) => crt.cerSrno === currCrt.cerSrno)
            );

            if (addedCerts.length > 0) {
              addedCerts.forEach(async (cCert) => {
                const cCertData = {
                  candidateId: currentCand.candidateId,
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  createdAt: new Date(),
                  lastUpdatedAt: new Date(),
                };
                const candCertUrl = `/rest/candDetails/external/AddCandCert`;
                await axiosInstance
                  .post(candCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res6) => {
                    console.log(res6.data);
                  });
              });
            }
            if (removeCerts.length > 0) {
              removeCerts.forEach(async (remove) => {
                const encryptedId = await fetchEncryptedToken(remove.cerSrno, token);
                if (!encryptedId) throw new Error('Failed to encrypt ID');

                if (remove?.cerSrno) {
                  await axiosInstance.delete(
                    `/rest/candDetails/external/deleteCertDtl/${encryptedId}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                }
              });
            }
            if (updtCerts.length > 0) {
              updtCerts.forEach(async (cCert) => {
                const cCertData = {
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  lastUpdatedAt: new Date(),
                };
                const updtCandCrtUrl = `/rest/candDetails/external/updateCertDtl/${cCert.cerSrno}`;
                await axiosInstance
                  .put(updtCandCrtUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => {
                    console.log('response= ', res5);
                  });
              });
            }
          }
        }

        if (activeStep === 6) {
          if (currentCandRefDtl || data.candRef) {
            const addedRefDtl = data.candRef.filter((ref) => ref.refSrno === 0);
            const updtRefDtl = data.candRef.filter((ref) => ref.refSrno !== 0);
            const removeRefDtl = cRefDtl.filter(
              (currRef) => !updtRefDtl.some((ref) => ref.refSrno === currRef.refSrno)
            );
            if (addedRefDtl.length > 0) {
              addedRefDtl.forEach(async (cRef) => {
                const cRefData = {
                  candidateId: currentCand.candidateId,
                  candidateReferenceName: encryptData(cRef.refNm),
                  candidateReferenceOrganizationName: encryptData(cRef.refOrgNm),
                  candidateReferenceDesignationId: cRef.refdesig,
                  candidateReferenceEmail: encryptData(cRef.refEmail),
                  candidateReferenceContactNumber: encryptData(cRef.refContact),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };

                const candRefUrl = `/rest/candDetails/external/addCandRef`;
                await axiosInstance
                  .post(candRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (removeRefDtl.length > 0) {
              removeRefDtl.forEach(async (remove) => {
                if (remove?.refSrno) {
                  await axiosInstance.delete(
                    `/rest/candDetails/external/deleteRef/${remove.refSrno}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                }
              });
            }
            if (updtRefDtl.length > 0) {
              updtRefDtl.forEach(async (cRef) => {
                const cRefData = {
                  candidateReferenceName: encryptData(cRef.refNm),
                  candidateReferenceOrganizationName: encryptData(cRef.refOrgNm),
                  candidateReferenceDesignationId: cRef.refdesig,
                  candidateReferenceEmail: encryptData(cRef.refEmail),
                  candidateReferenceContactNumber: encryptData(cRef.refContact),
                  lastUpdatedDate: new Date(),
                };
                const updtCandRefUrl = `/rest/candDetails/external/updtRef/${cRef.refSrno}`;
                await axiosInstance
                  .put(updtCandRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => { });
              });
            }
          }
        }

        if (activeStep === 5 || activeStep === steps.length - 1) {
          if (currentCandExpDtl || data.candExp) {
            const addedExpDtl = data.candExp.filter((exp) => exp.expSrno === 0);
            const updtExpDtl = data.candExp.filter((exp) => exp.expSrno !== 0);
            const removeExpDtl = cExpDtl.filter(
              (currExp) => !updtExpDtl.some((exp) => exp.expSrno === currExp.expSrno)
            );

            if (addedExpDtl.length > 0) {
              addedExpDtl.forEach(async (cExp) => {
                const cExpData = {
                  candidateId: currentCand.candidateId,
                  candidateExperienceCompanyName: cExp.compNm,
                  candidateDesignation: cExp.designation,
                  candidateCtcCurrency: cExp.ctccurncy,
                  candidateCtc: encryptData(cExp.ctc),
                  candidateCurrentlyWorking: cExp.currentywrkng,
                  candidateExperienceFromDate: cExp.expfromDate,
                  candidateExperienceToDate: cExp.exptoDate,
                  candidateExperienceCountryid: cExp.country,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candExpUrl = `/rest/candDetails/external/addCandExp`;
                await axiosInstance
                  .post(candExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => {
                    console.log(res5.data);
                  });
              });
            }
            if (removeExpDtl.length > 0) {
              removeExpDtl.forEach(async (remove) => {
                if (remove?.expSrno) {
                  await axiosInstance.delete(
                    `/rest/candDetails/external/deleteCandExp/${remove.expSrno}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                }
              });
            }
            if (updtExpDtl.length > 0) {
              updtExpDtl.forEach(async (cExp) => {
                const cExpData = {
                  candidateExperienceCompanyName: cExp.compNm,
                  candidateDesignation: cExp.designation,
                  candidateCtcCurrency: cExp.ctccurncy,
                  candidateCtc: encryptData(cExp.ctc),
                  candidateCurrentlyWorking: cExp.currentywrkng,
                  candidateExperienceFromDate: cExp.expfromDate,
                  candidateExperienceToDate: cExp.exptoDate,
                  candidateExperienceCountryid: cExp.country,
                  lastUpdatedDate: new Date(),
                };

                const updtCandExpUrl = `/rest/candDetails/external/updtCandExp/${cExp.expSrno}`;
                await axiosInstance
                  .put(updtCandExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => {
                    console.log('response= ', res5);
                  });
              });
            }
          }
        }

        if (activeStep === 2 || activeStep === steps.length - 1) {
          if (currentCandSkils) {
            if (cPskl) {
              const addedSkls = data.primaryskl.filter(
                (skill) => !cPskl.some((currentSkill) => currentSkill?.skillId === skill?.skillId)
              );
              const removedSkls = cPskl.filter(
                (currentSkill) =>
                  !data.primaryskl.some((skill) => skill?.skillId === currentSkill?.skillId)
              );
              if (removedSkls.length > 0) {
                removedSkls.forEach(async (removed) => {
                  const sid = removed?.skillId;
                  const cid = currentCand.publicId;

                  if (removed?.skillId) {
                    await axiosInstance.delete(
                      `/rest/candDetails/external/deleteCandSkl/${sid}/${cid}`,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );
                  }
                });
              }
              if (addedSkls.length > 0) {
                addedSkls.forEach(async (added) => {
                  const psklD = {
                    candidateId: currentCand.candidateId,
                    skill: added,
                    skillType: 'Primary',
                    createdDate: data.createdDate,
                    lastUpdatedDate: data.lastUpdatedDate,
                  };
                  const addPsklUrl = `/rest/candDetails/external/addCandSkill`;
                  await axiosInstance
                    .post(addPsklUrl, psklD, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .then((res1) => {
                      console.log(res1.data);
                    });
                });
              }
            }
            if (cSskl) {
              const addedSkls = data.secondskl.filter(
                (skill) => !cSskl.some((currentSkill) => currentSkill?.skillId === skill?.skillId)
              );
              const removedSkls = cSskl.filter(
                (currentSkill) =>
                  !data.secondskl.some((skill) => skill?.skillId === currentSkill?.skillId)
              );
              if (removedSkls.length > 0) {
                removedSkls.forEach(async (removed) => {
                  const sid = removed?.skillId;
                  const cid = currentCand.publicId;

                  if (removed?.skillId) {
                    await axiosInstance.delete(
                      `/rest/candDetails/external/deleteCandSkl/${sid}/${cid}`,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );
                  }
                });
              }
              if (addedSkls.length > 0) {
                addedSkls.forEach(async (added) => {
                  const psklD = {
                    candidateId: currentCand.candidateId,
                    skill: added,
                    skillType: 'Secondary',
                    createdDate: data.createdDate,
                    lastUpdatedDate: data.lastUpdatedDate,
                  };
                  const addPsklUrl = `/rest/candDetails/external/addCandSkill`;
                  await axiosInstance
                    .post(addPsklUrl, psklD, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .then((res1) => {
                      console.log(res1.data);
                    });
                });
              }
            }
          }
        }

        if (currentCandPrefLoc) {
          const addedLoc = data.prefloc.filter(
            (loc, index, self) =>
              self.findIndex((l) => l?.cityId === loc?.cityId) === index &&
              !cPrefLoc.some((currentPLoc) => currentPLoc?.cityId === loc?.cityId)
          );
          const removedLoc = cPrefLoc.filter(
            (currentPLoc) => !data.prefloc.some((loc) => loc?.cityId === currentPLoc?.cityId)
          );
          if (removedLoc.length > 0) {
            removedLoc.forEach(async (removed) => {
              const plid = removed?.cityId;
              const cid = currentCand.publicId;

              await axiosInstance.delete(
                `/rest/candDetails/external/deleteCandPLoc/${plid}/${cid}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
            });
          }
          if (addedLoc.length > 0) {
            addedLoc.forEach(async (added) => {
              const pLocD = {
                candidateId: currentCand.candidateId,
                prefLocCity: added,
                createdDate: data.createdDate,
                lastUpdatedDate: data.lastUpdatedDate,
              };
              const addPLocUrl = `/rest/candDetails/external/addCandPrefLoc`;
              await axiosInstance
                .post(addPLocUrl, pLocD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res3) => { });
            });
          }
        }
      } else {
        const formData = new FormData();
        formData.append('candD', JSON.stringify(candData));
        formData.append('resumeF', data.resumeUpload);
        if (data.avatarUrl instanceof File) {
          formData.append('profileP', data.avatarUrl);
        }

        const addCandUrl = `/rest/candidate/external/addCand`;
        await axiosInstance
          .post(addCandUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(async (res) => {
            const promises = [];

            setRFileNm('');
            const generatedEncryptedId = await fetchEncryptedToken(res.data.candidateId, token);
            if (!generatedEncryptedId) throw new Error('Failed to encrypt ID');

            data.primaryskl.forEach(async (pskl) => {
              const psklD = {
                candidateId: res.data.candidateId,
                skill: pskl,
                skillType: 'Primary',
                createdDate: data.createdDate,
                lastUpdatedDate: data.lastUpdatedDate,
              };
              const addPsklUrl = `/rest/candDetails/external/addCandSkill`;
              await axiosInstance
                .post(addPsklUrl, psklD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res1) => { });
            });
            data.secondskl.forEach(async (sskl) => {
              const ssklD = {
                candidateId: res.data.candidateId,
                skill: sskl,
                skillType: 'Secondary',
                createdDate: data.createdDate,
                lastUpdatedDate: data.lastUpdatedDate,
              };
              const addSsklUrl = `/rest/candDetails/external/addCandSkill`;
              await axiosInstance
                .post(addSsklUrl, ssklD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res2) => { });
            });

            data.prefloc.forEach(async (pLoc) => {
              const pLocD = {
                candidateId: res.data.candidateId,
                prefLocCity: pLoc,
                createdDate: data.createdDate,
                lastUpdatedDate: data.lastUpdatedDate,
              };
              const addPLocUrl = `/rest/candDetails/external/addCandPrefLoc`;
              await axiosInstance
                .post(addPLocUrl, pLocD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res3) => { });
            });

            data.candEdu.forEach(async (cEdu) => {
              const cEduData = {
                candidateId: res.data.candidateId,
                university: cEdu.university,
                qualification: cEdu.qualification,
                qualificationTypeId: cEdu.qualtype,
                stream: cEdu.stream,
                candidateQualPercentage: cEdu.candpercnt,
                candidateQualCgpa: cEdu.candcgpa,
                currentlyPursuing: cEdu.currentypurs,
                candidateQualFromDate: cEdu.edufromDate,
                candidateQualToDate: cEdu.edutoDate,
                createdDate: new Date(),
                lastUpdatedDate: new Date(),
              };
              const addCandEduUrl = `/rest/candDetails/external/addCandEdu`;
              await axiosInstance
                .post(addCandEduUrl, cEduData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res4) => { });
            });

            data.candExp.forEach(async (cExp) => {
              const cExpData = {
                candidateId: res.data.candidateId,
                candidateExperienceCompanyName: cExp.compNm,
                candidateDesignation: cExp.designation,
                candidateCtcCurrency: cExp.ctccurncy,
                candidateCtc: encryptData(cExp.ctc),
                candidateCurrentlyWorking: cExp.currentywrkng,
                candidateExperienceFromDate: cExp.expfromDate,
                candidateExperienceToDate: cExp.exptoDate,
                candidateExperienceCountryid: cExp.country,
                createdDate: new Date(),
                lastUpdatedDate: new Date(),
              };
              const candExpUrl = `/rest/candDetails/external/addCandExp`;
              await axiosInstance
                .post(candExpUrl, cExpData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res5) => { });
            });

            data.candCert.forEach(async (cCert) => {
              const cCertData = {
                candidateId: res.data.candidateId,
                certificationName: cCert.certiNm,
                instituteName: cCert.certiInstiNm,
                durationFrom: cCert.certfromDate,
                durationTo: cCert.certtoDate,
                createdDate: new Date(),
                lastUpdatedDate: new Date(),
              };
              const candCertUrl = `/rest/candDetails/external/AddCandCert`;
              await axiosInstance
                .post(candCertUrl, cCertData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res6) => { });
            });

            data.candRef.forEach(async (cRef) => {
              const cRefData = {
                candidateId: res.data.candidateId,
                candidateReferenceName: encryptData(cRef.refNm),
                candidateReferenceOrganizationName: encryptData(cRef.refOrgNm),
                candidateReferenceDesignationId: cRef.refdesig,
                candidateReferenceEmail: encryptData(cRef.refEmail),
                candidateReferenceContactNumber: encryptData(cRef.refContact),
                createdDate: new Date(),
                lastUpdatedDate: new Date(),
              };
              const candRefUrl = `/rest/candDetails/external/addCandRef`;
              await axiosInstance
                .post(candRefUrl, cRefData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res7) => { });
            });
            await Promise.all(promises);

            if (activeStep === steps.length - 1 || steps === 'Reference Details') {
              const activeTagEmail = tagEmail || localStorage.getItem('tagEmail') || '';
              if (activeTagEmail) {
                try {
                  await axiosInstance.post(
                    `/rest/candidate/external/finalSubmit`,
                    {
                      tagEmail: encryptData(activeTagEmail),
                      candidateName: `${data.fname} ${data.lname}`,
                      candidateEmail: data.email,
                      positionName: data.positionName?.positionName || '',
                      updatedDate: new Date().toLocaleDateString('en-GB'),
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                } catch (mailErr) {
                  console.error('Final submit email trigger error:', mailErr);
                }
              }
              if (data.email) {
                const normalized = data.email.toLowerCase().trim();
                localStorage.setItem(`cand_submitted_${normalized}`, 'true');
                localStorage.setItem(`cand_submitted_time_${normalized}`, String(Date.now()));
              }
              router.push(paths.submitted);
            } else {
              handleSave();
              enqueueSnackbar('Draft saved successfully!', { variant: 'success' });

              const nextId = res.data?.publicId || generatedEncryptedId;
              localStorage.setItem('activeStep_new', activeStep.toString());
              localStorage.setItem('activeStepKey', (activeStep + 1).toString());
              if (res.data?.candidateId) {
                localStorage.setItem(`activeStep_${res.data.candidateId}`, (activeStep + 1).toString());
              }

              const isVendor = window.location.pathname.includes('vendorCandidateForm')
                || Boolean(new URLSearchParams(window.location.search).get('vendorId'))
                || sessionStorage.getItem('isVendorCandidateForm') === 'true';

              if (isVendor) {
                router.push(`/vendorCandidateForm/${nextId}${window.location.search}`);
              } else {
                router.push(paths.candeditForm(nextId));
              }
            }
          });
      }
    } catch (error) {
      console.error(error);
      const message =
        error?.response?.data?.message || error?.message || 'An unexpected error occurred';

      enqueueSnackbar(message, { variant: 'error' });
      loadingSend.onFalse();

      if (!error?.response?.data?.message) {
        handleApiError(error);
      }
    }
  };

  const onSubmit = handleSubmit(executeFormSubmission);

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        const maxMb = maxSizeOfDocs || 3;
        const isTooLarge = file.size / (1024 * 1024) > maxMb;
        setIsFileTooLarge(isTooLarge);

        if (!isTooLarge) {
          const newFile = Object.assign(file, {
            preview: URL.createObjectURL(file),
          });

          setValue('avatarUrl', newFile, { shouldValidate: true });
          setCurCandPic(true);
        } else {
          setValue('avatarUrl', null, { shouldValidate: true });
          setCurCandPic(false);
        }
      }
    },
    [setValue, maxSizeOfDocs]
  );

  const handleRemovePhoto = useCallback(() => {
    setIsProfilePhotoRemoved(true);
    setCurCandPic(null);
    setValue('avatarUrl', null);
    setProfilePhotoUrl(null);
    setIsFileTooLarge(false);
  }, [setValue]);

  const isStepOptional = (step) => step === 1;

  const isStepSkipped = (step) => skipped?.has(step);

  const DynamicData = methods.getValues();

  const candidateId = currentCand?.candidateId;

  const expInYears = watch('expinyrs');

  useEffect(() => {
    trigger('relexp');
  }, [expInYears, trigger]);

  const handleSave = useCallback(
    async () => {
      const fieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});

      if (fieldKeys.length > 0) {
        const isValid = await trigger(fieldKeys);
        if (!isValid) {
          enqueueSnackbar('Please complete all required fields before saving.', {
            variant: 'warning',
          });
        }
      }

      if (currentCand) {
        localStorage.setItem(`activeStep_${candidateId}`, activeStep.toString());
      } else {
        localStorage.setItem('activeStepKey', activeStep.toString());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeStep, currentCand]
  );

  const handleNext = async () => {
    if (disabled) {
      setActiveStep((prev) => {
        const newStep = prev + 1;
        localStorage.setItem(`activeStep_${candidateId || 'new'}`, newStep.toString());
        return newStep;
      });
      handleStepChange(activeStep + 1);
      return;
    }

    const currentStepFields = Object.keys(stepsvalidator[activeStep].fields);
    const isValid = await trigger(currentStepFields);

    if (!isValid) {
      enqueueSnackbar('Please complete all required fields before proceeding.', {
        variant: 'warning',
      });
      setStepCompletionStatus((prev) => {
        const newStatus = [...prev];
        newStatus[activeStep] = false;
        return newStatus;
      });
      return;
    }

    if (activeStep === steps.length - 1) {
      enqueueSnackbar("Don't forget to save your changes before proceeding to the next step!", {
        variant: 'warning',
        autoHideDuration: 3000,
      });
    }

    setActiveStep((prev) => {
      const newStep = prev + 1;
      localStorage.setItem(`activeStep_${candidateId || 'new'}`, newStep.toString());
      return newStep;
    });

    handleStepChange(activeStep + 1);

    setStepCompletionStatus((prev) => {
      const newStatus = [...prev];
      newStatus[activeStep] = isValid;
      return newStatus;
    });
  };

  const handleBack = () => {
    setActiveStep((prev) => {
      const newStep = Math.max(prev - 1, 0);
      localStorage.setItem(`activeStep_${candidateId || 'new'}`, newStep.toString());
      return newStep;
    });
    handleStepChange(Math.max(activeStep - 1, 0));
  };

  const handleSaveNext = async () => {
    const currentStepFields = Object.keys(stepsvalidator[activeStep].fields);
    const isValid = await trigger(currentStepFields);

    if (!isValid) {
      enqueueSnackbar('Please complete all required fields before proceeding.', {
        variant: 'warning',
      });
      return;
    }

    await new Promise((res) => setTimeout(res, 0));

    const formData = methods.getValues();

    await handleFormSubmission(formData, true);

    if (candidateId) {
      localStorage.setItem(`activeStep_${candidateId}`, (activeStep + 1).toString());
    } else {
      localStorage.setItem('activeStepKey', (activeStep + 1).toString());
    }

    setActiveStep((prev) => prev + 1);
    handleStepChange(activeStep + 1);

    setStepCompletionStatus((prev) => {
      const newStatus = [...prev];
      newStatus[activeStep] = true;
      return newStatus;
    });
  };

  const [changedSections, setChangedSections] = useState({
    basicDetails: false,
    personalDetails: false,
    professionalDetails: false,
    educationDetails: false,
    certificationDetails: false,
    experienceDetails: false,
    referenceDetails: false,
  });

  const activeStepKey = `activeStep_${candidateId || 'new'}`;

  const validateAllSteps = async () => {
    const newStepStatus = [...stepCompletionStatus];

    const validationResults = await Promise.all(
      stepsvalidator.map(async (step, index) => {
        const fieldKeys = Object.keys(step.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await trigger(fieldKeys);
          newStepStatus[index] = isValid;
          return isValid;
        }
        newStepStatus[index] = true;
        return true;
      })
    );

    setStepCompletionStatus(newStepStatus);

    const allValid = validationResults.every((result) => result === true);
    return allValid;
  };

  const handleFinalSubmitClick = async () => {
    const data = methods.getValues();

    try {
      const isValid = await validateAllSteps();

      if (!isValid) {
        enqueueSnackbar('Please complete all required steps before submitting.', {
          variant: 'warning',
        });
        return;
      }

      await executeFormSubmission({ ...data, isFinalStep: true });

      const activeTagEmail = tagEmail || localStorage.getItem('tagEmail') || '';
      if (activeTagEmail) {
        try {
          await axiosInstance.post(
            `/rest/candidate/external/finalSubmit`,
            {
              tagEmail: encryptData(activeTagEmail),
              candidateName: `${data.fname} ${data.lname}`,
              candidateEmail: data.email,
              positionName: currentCand?.positionName || data.positionName?.positionName || '',
              updatedDate: new Date().toLocaleDateString('en-GB'),
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } catch (mailErr) {
          console.error('Final submit notification error:', mailErr);
        }
      }

      if (data.email) {
        const normalized = data.email.toLowerCase().trim();
        localStorage.setItem(`cand_submitted_${normalized}`, 'true');
        localStorage.setItem(`cand_submitted_time_${normalized}`, String(Date.now()));
      }

      router.push(paths.submitted);
    } catch (err) {
      console.error('Final submission failed:', err?.response || err);
      enqueueSnackbar(err?.response?.data?.message || err?.message || 'Submission failed', {
        variant: 'error',
      });
    }
  };

  const handleFormSubmission = async (data) => {
    loadingSend.onTrue();
    try {
      const isValid = await validateAllSteps();
      if (isValid) {
        await executeFormSubmission(data);
      } else {
        enqueueSnackbar('Please complete all required steps before submitting.', {
          variant: 'warning',
        });
      }
    } catch (error) {
      console.error('Error in form submission:', error);
    } finally {
      loadingSend.onFalse();
    }
  };

  const memoizedMethods = useCallback(methods, [methods]);

  useEffect(() => {
    const candidateId = currentCand?.candidateId;

    if (disabled) {
      setActiveStep(0);
      return;
    }

    const restoreAndValidate = async (parsedStep, stepperKey) => {
      const savedFormData = JSON.parse(localStorage.getItem(`stepperFormData_${stepperKey}`));

      if (savedFormData) {
        await Promise.all(
          Object.entries(savedFormData).map(([key, value]) =>
            methods.setValue(key, value, {
              shouldTouch: false,
              shouldDirty: false,
              shouldValidate: false,
            })
          )
        );
      }

      await new Promise((resolve) => setTimeout(resolve, 100));

      const newStatus = [...stepCompletionStatus];
      for (let i = 0; i < parsedStep; i += 1) {
        const fieldKeys = Object.keys(stepsvalidator[i]?.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await methods.trigger(fieldKeys);
          newStatus[i] = isValid;
        } else {
          newStatus[i] = true;
        }
      }

      setStepCompletionStatus(newStatus);
    };

    if (!candidateId) {
      methods.reset();
      localStorage.removeItem('stepperFormData_new');
      setActiveStep(0);

      const initialStatus = steps.map(() => true);
      setStepCompletionStatus(initialStatus);

      return;
      // eslint-disable-next-line no-else-return
    } else {
      const savedStep = localStorage.getItem('activeStep_new');
      const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
      setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);
      restoreAndValidate(parsedStep, candidateId);
    }

    const candidateStepKey = `activeStep_${candidateId}`;
    const newStep = localStorage.getItem('activeStep_new');
    const existingStep = localStorage.getItem(candidateStepKey);

    if (newStep && !existingStep) {
      const parsedStep = parseInt(newStep, 10);
      const nextStep = Number.isNaN(parsedStep) ? 0 : parsedStep + 1;

      localStorage.setItem(candidateStepKey, nextStep.toString());
      localStorage.setItem('activeStepKey', nextStep.toString());
      localStorage.removeItem('activeStep_new');

      setActiveStep(nextStep);
      restoreAndValidate(nextStep, candidateId);
      return;
    }

    const savedStep =
      localStorage.getItem(candidateStepKey) || localStorage.getItem('activeStepKey');
    const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
    setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);

    restoreAndValidate(parsedStep, candidateId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCand, disabled, methods]);

  const handleSwitchChange = (event, section) => {
    const isChecked = event.target.checked;

    setSwitchState((prevState) => ({
      ...prevState,
      [section]: isChecked,
    }));

    if (section === 'experience' && isChecked) {
      setValue('candExp', [
        {
          expSrno: 0,
          compNm: '',
          designation: null,
          ctc: 0,
          ctccurncy: null,
          country: null,
          currentywrkng: false,
          expfromDate: null,
          exptoDate: null,
        },
      ]);
    }

    if (section === 'experience' && !isChecked) {
      setValue('candExp', []);
    }
  };

  const handleNoExperience = () => {
    setValue('candExp', []);
    setSwitchState((prev) => ({ ...prev, experience: false }));
  };

  return (
    <>
      {isResumeProcessing && (
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isResumeProcessing}
        >
          <Stack alignItems="center">
            <CircularProgress color="inherit" />
            <Typography variant="h6" mt={2}>
              Processing resume, It will take some time please wait...
            </Typography>
          </Stack>
        </Backdrop>
      )}

      <Stepper activeStep={activeStep} sx={{ mb: 1, padding: '0px !important', marginTop: '8px' }}>
        {steps.map((label, index) => (
          <Step
            key={index}
            sx={{
              '&:hover': { cursor: 'pointer', backgroundColor: '#f2f3f4', borderRadius: '8px' },
            }}
          >
            <StepLabel
              StepIconProps={{
                completed: stepCompletionStatus[index] === true && index < activeStep,
                icon: (() => {
                  if (index === activeStep) {
                    return activeStep + 1;
                  }
                  if (stepCompletionStatus[index] === true) {
                    return index + 1;
                  }
                  if (stepCompletionStatus[index] === false && index <= activeStep) {
                    return (
                      <span
                        style={{
                          backgroundColor: '#f2f3f4',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        <img
                          src="/assets/icons/menu-items/material-symbols--exclamation.png"
                          alt="❗"
                          style={{ height: '25px', width: '25px' }}
                        />
                      </span>
                    );
                  }
                  return index + 1;
                })(),
              }}
              sx={{
                fontWeight: 200,
                cursor: 'pointer',
                borderRadius: '8px',
                position: 'sticky',
                padding: '0px !important',
                transition: 'background-color 0.3s ease',
                '&:hover': { color: 'primary.dark', cursor: 'pointer', backgroundColor: '#f2f3f4' },
              }}
              onClick={async () => {
                if (index === activeStep) return;

                const newStatus = [...stepCompletionStatus];

                const currentFieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});
                if (currentFieldKeys.length > 0) {
                  const isValid = await trigger(currentFieldKeys);
                  newStatus[activeStep] = isValid;
                }

                const targetFieldKeys = Object.keys(stepsvalidator[index]?.fields || {});
                if (targetFieldKeys.length > 0) {
                  const isTargetValid = await trigger(targetFieldKeys);
                  newStatus[index] = isTargetValid;
                }

                setStepCompletionStatus(newStatus);

                setActiveStep(index);

                localStorage.setItem(activeStepKey, index.toString());
                handleStepChange(index);
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      <Container maxWidth={false} disableGutters>
        <Box sx={{ px: 2 }}>
          <Card
            sx={{
              p: 3,
              width: '100%',
              margin: 'auto',
              transformOrigin: 'top center',
            }}
          >
            <FormProvider methods={methods} disabled={disabled}>
              <Grid container spacing={3}>
                <Grid xs={12} md={12}>
                  {activeStep === 0 && (
                    <>
                      <Grid xs={12} md={12} sx={{ pr: 0 }}>
                        <Box sx={{ mb: 1 }}>
                          <RHFUploadAvatar
                            name="avatarUrl"
                            maxSize={(maxSizeOfDocs || 3) * 1024 * 1024}
                            onDrop={handleDrop}
                            disabled={disabled}
                            helperText={
                              !disabled && (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    mt: 2,
                                    mx: 'auto',
                                    display: 'block',
                                    textAlign: 'center',
                                    color: 'text.secondary',
                                  }}
                                >
                                  Supported file formats: JPG, JPEG, PNG,
                                  <Tooltip
                                    title="Additional formats: GIF, SVG, HEIC, HEIF, TIFF, WebP, JFIF"
                                    arrow
                                    placement="top"
                                  >
                                    <Typography
                                      variant="caption"
                                      component="span"
                                      sx={{
                                        cursor: 'pointer',
                                        ml: 0.5,
                                        textDecoration: 'underline',
                                        color: 'primary.main',
                                      }}
                                    >
                                      (more)
                                    </Typography>
                                  </Tooltip>
                                  <br />
                                  Max upload file size : {maxSizeOfDocs || 3} MB
                                </Typography>
                              )
                            }
                          />
                          {!disabled &&
                            !isFileTooLarge &&
                            (curCandPic || (currentCand?.profilePhoto && !isProfilePhotoRemoved)) && (
                              <>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                  <Button
                                    variant="soft"
                                    color="error"
                                    onClick={openConfirmDialog}
                                    disabled={!curCandPic && !currentCand?.profilePhoto}
                                  >
                                    Remove Photo
                                  </Button>
                                </Box>

                                <ConfirmDialog
                                  open={confirmOpen}
                                  onClose={closeConfirmDialog}
                                  title="Remove Photo?"
                                  content="Are you sure you want to remove the photo?"
                                  action={
                                    <Button
                                      variant="contained"
                                      color="error"
                                      onClick={() => {
                                        handleRemovePhoto();
                                        closeConfirmDialog();
                                      }}
                                    >
                                      Confirm Remove
                                    </Button>
                                  }
                                />
                              </>
                            )}
                        </Box>
                      </Grid>

                      <br />
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        {currentCand ? (
                          <>
                            {currentCand.resume && uploadClick ? (
                              <Box
                                ref={fileInputRef}
                                onDragEnter={handleDragEnter}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleFileDropWrapper}
                              >
                                <RHFUploadBox
                                  name="resumeUpload"
                                  onDrop={(acceptedFiles) => {
                                    handleFileDropWrapper();
                                    handleDropResume(acceptedFiles);
                                  }}
                                  disabled={disabled}
                                  acceptFile={{
                                    'application/pdf': [],
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                                      [],
                                    'application/msword': [],
                                    'text/plain': [],
                                    'application/vnd.ms-powerpoint': [],
                                    'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
                                      [],
                                    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                                      [],
                                  }}
                                  onDelete={() =>
                                    setValue('resumeUpload', null, { shouldValidate: true })
                                  }
                                  minSize={1000}
                                  maxSize={3000000}
                                  placeholder={
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      sx={{ color: 'text.secondary' }}
                                    >
                                      <Iconify
                                        icon="eva:cloud-upload-fill"
                                        style={{
                                          width: '48px',
                                          height: '48px',
                                          color: '#1976d2',
                                        }}
                                      />

                                      <Typography
                                        variant="body1"
                                        sx={{
                                          mt: 1,
                                          fontWeight: 600,
                                        }}
                                      >
                                        Drag & Drop or Upload Resume Here
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{
                                    p: 0,
                                    m: 0,
                                    width: '100%',
                                    height: 'auto',
                                    border: 'none !important',
                                    outline: 'none !important',
                                    boxShadow: 'none !important',
                                    bgcolor: 'transparent !important',
                                    '& > div:first-of-type': {
                                      py: 2.5,
                                      px: 3,
                                      width: '100%',
                                      height: 'auto',
                                      minHeight: 120,
                                      borderRadius: 1.5,
                                      border: isDragOver
                                        ? '2px dashed #1976d2 !important'
                                        : '1.5px dashed rgba(145, 158, 171, 0.32)',
                                      bgcolor: isDragOver
                                        ? 'rgba(25, 118, 210, 0.12) !important'
                                        : 'transparent',
                                      transform: isDragOver ? 'translateY(-2px)' : 'none',
                                      boxShadow: isDragOver
                                        ? '0 8px 24px -4px rgba(25, 118, 210, 0.3) !important'
                                        : 'none',
                                      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        opacity: 1,
                                        borderColor: '#1976d2',
                                        borderStyle: 'dashed',
                                        bgcolor: 'rgba(25, 118, 210, 0.08)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 8px 24px -4px rgba(25, 118, 210, 0.25)',
                                        '& svg, & div': {
                                          transform: 'scale(1.08) translateY(-2px)',
                                          transition: 'transform 0.25s ease',
                                        },
                                        '& p, & span': {
                                          color: '#1976d2',
                                          transition: 'color 0.25s ease',
                                        },
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box
                                ref={fileInputRef}
                                onDragEnter={handleDragEnter}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleFileDropWrapper}
                              >
                                <RHFUploadBox
                                  name="resumeUpload"
                                  onDrop={(acceptedFiles) => {
                                    handleFileDropWrapper();
                                    handleDropResume(acceptedFiles);
                                  }}
                                  disabled={disabled}
                                  acceptFile={{
                                    'application/pdf': [],
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                                      [],
                                    'application/msword': [],
                                    'text/plain': [],
                                    'application/vnd.ms-powerpoint': [],
                                    'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
                                      [],
                                    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                                      [],
                                  }}
                                  onDelete={() =>
                                    setValue('resumeUpload', null, { shouldValidate: true })
                                  }
                                  minSize={1000}
                                  maxSize={3000000}
                                  placeholder={
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      sx={{
                                        color: 'text.secondary',
                                        py: 3,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 64,
                                          height: 64,
                                          borderRadius: '50%',
                                          background:
                                            'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          mb: 2,
                                          boxShadow: '0 6px 16px rgba(25,118,210,0.25)',
                                        }}
                                      >
                                        <Iconify
                                          icon="eva:cloud-upload-fill"
                                          style={{
                                            width: '32px',
                                            height: '32px',
                                            color: '#fff',
                                          }}
                                        />
                                      </Box>

                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 600,
                                          color: '#334155',
                                        }}
                                      >
                                        Drag & Drop Resume Here
                                      </Typography>

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          mt: 0.5,
                                          color: '#64748b',
                                        }}
                                      >
                                        or click to browse
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{
                                    p: 0,
                                    m: 0,
                                    width: '100%',
                                    height: 'auto',
                                    border: 'none !important',
                                    outline: 'none !important',
                                    boxShadow: 'none !important',
                                    bgcolor: 'transparent !important',
                                    '& > div:first-of-type': {
                                      py: 2.5,
                                      px: 3,
                                      width: '100%',
                                      height: 'auto',
                                      minHeight: 120,
                                      borderRadius: 1.5,
                                      border: isDragOver
                                        ? '2px dashed #1976d2 !important'
                                        : '1.5px dashed rgba(145, 158, 171, 0.32)',
                                      bgcolor: isDragOver
                                        ? 'rgba(25, 118, 210, 0.12) !important'
                                        : 'transparent',
                                      transform: isDragOver ? 'translateY(-2px)' : 'none',
                                      boxShadow: isDragOver
                                        ? '0 8px 24px -4px rgba(25, 118, 210, 0.3) !important'
                                        : 'none',
                                      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        opacity: 1,
                                        borderColor: '#1976d2',
                                        borderStyle: 'dashed',
                                        bgcolor: 'rgba(25, 118, 210, 0.08)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 8px 24px -4px rgba(25, 118, 210, 0.25)',
                                        '& svg, & div': {
                                          transform: 'scale(1.08) translateY(-2px)',
                                          transition: 'transform 0.25s ease',
                                        },
                                        '& p, & span': {
                                          color: '#1976d2',
                                          transition: 'color 0.25s ease',
                                        },
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            )}

                            {currentCand.resume && (
                              <ConfirmDialog
                                open={confirm.value}
                                onClose={confirm.onFalse}
                                title="Edit Resume"
                                content="Are you sure want to overwrite existing resume?"
                                action={
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    onClick={() => {
                                      setUploadClick(false);
                                      confirm.onFalse();
                                    }}
                                  >
                                    Upload
                                  </Button>
                                }
                              />
                            )}
                          </>
                        ) : (
                          <Box
                            onDragEnter={handleDragEnter}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleFileDropWrapper}
                          >
                            <RHFUploadBox
                              name="resumeUpload"
                              onDrop={(acceptedFiles) => {
                                handleFileDropWrapper();
                                handleDropResume(acceptedFiles);
                              }}
                              acceptFile={{
                                'application/pdf': [],
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                                  [],
                                'application/msword': [],
                                'text/plain': [],
                                'application/vnd.ms-powerpoint': [],
                                'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
                                  [],
                                'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                                  [],
                              }}
                              onDelete={() => setValue('resumeUpload', null, { shouldValidate: true })}
                              minSize={1000}
                              maxSize={3000000}
                              placeholder={
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                  justifyContent="center"
                                  width="100%"
                                  sx={{ color: 'text.secondary' }}
                                >
                                  <Iconify
                                    icon="eva:cloud-upload-fill"
                                    style={{
                                      width: '48px',
                                      height: '48px',
                                      color: '#1976d2',
                                    }}
                                  />

                                  <Typography
                                    variant="body1"
                                    sx={{
                                      mt: 1,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Drag & Drop or Upload Resume Here
                                  </Typography>
                                </Box>
                              }
                              sx={{
                                p: 0,
                                m: 0,
                                width: '100%',
                                height: 'auto',
                                border: 'none !important',
                                outline: 'none !important',
                                boxShadow: 'none !important',
                                bgcolor: 'transparent !important',
                                '& > div:first-of-type': {
                                  py: 2.5,
                                  px: 3,
                                  width: '100%',
                                  height: 'auto',
                                  minHeight: 120,
                                  borderRadius: 1.5,
                                  border: isDragOver
                                    ? '2px dashed #1976d2 !important'
                                    : '1.5px dashed rgba(145, 158, 171, 0.32)',
                                  bgcolor: isDragOver
                                    ? 'rgba(25, 118, 210, 0.12) !important'
                                    : 'transparent',
                                  transform: isDragOver ? 'translateY(-2px)' : 'none',
                                  boxShadow: isDragOver
                                    ? '0 8px 24px -4px rgba(25, 118, 210, 0.3) !important'
                                    : 'none',
                                  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                  cursor: 'pointer',
                                  '&:hover': {
                                    opacity: 1,
                                    borderColor: '#1976d2',
                                    borderStyle: 'dashed',
                                    bgcolor: 'rgba(25, 118, 210, 0.08)',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 8px 24px -4px rgba(25, 118, 210, 0.25)',
                                    '& svg, & div': {
                                      transform: 'scale(1.08) translateY(-2px)',
                                      transition: 'transform 0.25s ease',
                                    },
                                    '& p, & span': {
                                      color: '#1976d2',
                                      transition: 'color 0.25s ease',
                                    },
                                  },
                                },
                              }}
                            />
                          </Box>
                        )}
                        <Box
                          rowGap={3}
                          columnGap={2}
                          display="flex"
                          alignItems="center"
                          gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                          }}
                        >
                          {currentCand?.resume && !rFileNm ? (
                            <Tooltip title="Download Resume" placement="top" arrow>
                              <Button
                                onClick={() => downloadResume(currentCand.resume)}
                                className="doNotDisable"
                              >
                                {getResumeIcon()}
                                <Typography ml={1} className="doNotDisable">
                                  {decryptData(currentCand.email)}.{rFileNm ? resumeTyp : (currentCand.resume?.split('.').pop().toLowerCase() || '')}
                                </Typography>
                              </Button>
                            </Tooltip>
                          ) : (
                            <>
                              {rFileNm ? getResumeIcon() : ''}
                              <Typography>{!rFileNm ? 'No file Uploaded' : rFileNm}</Typography>
                              {rFileNm && (
                                <Button variant="text" color="secondary" onClick={handleRemoveResume} sx={{ borderRadius: '50%', minWidth: '30px', padding: '4px' }}>
                                  <Iconify icon="entypo:cross" style={{ color: 'red' }} />
                                </Button>
                              )}
                            </>
                          )}
                        </Box>

                        <Box sx={{ gridColumn: { xs: '1 / -1', sm: 'span 1' } }}>
                          <Stack spacing={1.5}>
                            <Controller
                              name="positionName"
                              control={control}
                              render={({ field }) => {
                                const isClosedOrHist = Boolean(field.value?.isClosedOrHistorical);
                                const isPositionDisabled = isJoinedCandidate || isClosedOrHist;
                                const tooltipTitle = isJoinedCandidate
                                  ? 'This candidate has already joined as an employee. Position applied for cannot be changed.'
                                  : isClosedOrHist
                                    ? 'Requisition for this position is closed/cancelled. Position applied for cannot be changed.'
                                    : '';

                                return (
                                  <Tooltip
                                    title={tooltipTitle}
                                    placement="top"
                                    arrow
                                    disableHoverListener={!isPositionDisabled}
                                  >
                                    <Box component="div" sx={{ width: '100%' }}>
                                      <Autocomplete
                                        {...field}
                                        disabled={isPositionDisabled}
                                        options={openPositionsArr}
                                        getOptionLabel={(option) => {
                                          if (!option) return '';
                                          if (typeof option === 'string') return option;
                                          if (option.isClosedOrHistorical) {
                                            return `${option.positionName} (Closed/Cancelled)`;
                                          }
                                          return option?.positionName
                                            ? `${option.positionName} (${option.experienceFrom || 0} - ${option.experienceTo || 0} years)`
                                            : '';
                                        }}
                                        isOptionEqualToValue={(option, value) =>
                                          option?.candidateRequisitionId === value?.candidateRequisitionId ||
                                          option?.positionName === value?.positionName
                                        }
                                        onChange={(event, newValue) => field.onChange(newValue)}
                                        value={field.value || null}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label={
                                              <div>
                                                Position Applied For
                                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                              </div>
                                            }
                                            placeholder="Select Open Position"
                                            error={!!errors.positionName}
                                            helperText={errors.positionName?.message}
                                          />
                                        )}
                                      />
                                    </Box>
                                  </Tooltip>
                                );
                              }}
                            />
                          </Stack>
                        </Box>
                        <br />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="srcofhire"
                            placeholder="Source Of Hire"
                            label={
                              <div>
                                Source Of Hire
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={srcOfHrArr}
                            getOptionLabel={(option) => option.sourceName || ''}
                            renderOption={(props, option) => (
                              <li {...props} key={option.sourceOfHireId}>
                                {option.sourceName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField
                          name="srcofhireNm"
                          label="Source Name"
                          disabled={
                            window.location.pathname.includes('vendorCandidateForm') ||
                            sessionStorage.getItem('isVendorCandidateForm') === 'true'
                          }
                        />
                      </Box>
                    </>
                  )}

                  {/* =============================== Personal Details============================ */}
                  {activeStep === 1 && (
                    <>
                      <Box>
                        <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                          Personal Details:
                        </Typography>
                      </Box>
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        <RHFTextField
                          name="fname"
                          label={
                            <div>
                              First Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box component="span" sx={{ color: 'text.disabled' }}>
                                  <RHFAutocomplete
                                    name="nameTitle"
                                    disableClearable
                                    sx={{
                                      '& fieldset': { border: 'none' },
                                    }}
                                    options={nmTitleArr}
                                    getOptionLabel={(option) => option.masterName}
                                    componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option.masterId}>
                                        {option.masterName}
                                      </li>
                                    )}
                                  />
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <RHFTextField name="mname" label="Middle Name" />
                        <RHFTextField
                          name="lname"
                          label={
                            <div>
                              Last Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField
                          name="email"
                          label={
                            <div>
                              Email<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField
                          name="mobno"
                          label={
                            <div>
                              Mobile Number
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={blockInvalidChar}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box component="span" sx={{ color: 'text.disabled' }}>
                                  <RHFAutocomplete
                                    name="phncode"
                                    disableClearable
                                    filterOptions={filterPhoneCode}
                                    sx={{
                                      '& fieldset': { border: 'none' },
                                    }}
                                    options={countryArr}
                                    getOptionLabel={(option) => option?.phoneCode || ''}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.countriesId === value?.countriesId ||
                                      option?.phoneCode === value?.phoneCode
                                    }
                                    componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                    onChange={(event, value) => {
                                      setValue('phncode', value, { shouldValidate: true });
                                      trigger('mobno');
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option.shortName || option.countriesId}>
                                        {option.countryName}({option.phoneCode})
                                      </li>
                                    )}
                                  />
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="gender"
                            placeholder="Gender"
                            label={
                              <div>
                                Gender<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={genderArr}
                            getOptionLabel={(option) => option?.masterName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.masterId}>
                                {option.masterName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack>
                          <RHFAutocomplete
                            name="cuurntloc"
                            placeholder="Current Location(City)"
                            disableClearable
                            ListboxComponent={ListboxComponent}
                            label={
                              <div>
                                Current Location(City)
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={cityArr}
                            getOptionLabel={(option) => option?.cityName}
                            renderOption={(props, option) => (
                              <li {...props} key={option?.cityId}>
                                {option.cityName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFAutocomplete
                          name="prefloc"
                          label="Preferred Location(City)"
                          placeholder="+ Preferred Location(City) "
                          disableClearable
                          multiple
                          ListboxComponent={ListboxComponent}
                          options={cityArr}
                          getOptionLabel={(option) => option.cityName || ''}
                          isOptionEqualToValue={(option, value) => option?.cityName === value?.cityName}
                          renderOption={(props, option) => (
                            <li {...props} key={option?.cityId}>
                              {option?.cityName}
                            </li>
                          )}
                          renderTags={(selected, getTagProps) =>
                            selected
                              .filter((option) => option && option?.cityId)
                              .map((option, index) => (
                                <Chip
                                  {...getTagProps({ index })}
                                  key={option?.cityId}
                                  label={option?.cityName}
                                  size="small"
                                  color="info"
                                  variant="soft"
                                />
                              ))
                          }
                        />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="uniqueNum"
                            placeholder="Unique Identity Document"
                            label="Unique Identity Document"
                            disableClearable
                            options={uniqueNum}
                            getOptionLabel={(option) => option}
                            onChange={(event, value) => {
                              setValue('uniqueNum', value, { shouldValidate: true });
                              setUniqueNumber(value);
                              setValue('uniqueno', '', { shouldValidate: true });
                              trigger('uniqueno');
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option}>
                                {option}
                              </li>
                            )}
                          />
                        </Stack>
                        {uniqueNumber === 'PAN' && (
                          <Controller
                            name="uniqueno"
                            control={methods.control}
                            rules={{ required: 'PAN is required' }}
                            render={({ field, fieldState }) => (
                              <MaskedInput
                                field={field}
                                error={fieldState.error}
                                maskType="PAN"
                                label={
                                  <div>
                                    Pan Card Number{' '}
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}>*</span>
                                  </div>
                                }
                              />
                            )}
                          />
                        )}

                        {uniqueNumber === 'AADHAR' && (
                          <Controller
                            name="uniqueno"
                            control={methods.control}
                            rules={{ required: 'Aadhar is required' }}
                            render={({ field, fieldState }) => (
                              <MaskedInput
                                field={field}
                                error={fieldState.error}
                                maskType="AADHAAR"
                                label={
                                  <div>
                                    Aadhar Card Number{' '}
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}>*</span>
                                  </div>
                                }
                              />
                            )}
                          />
                        )}

                        <Stack spacing={1}>
                          <RHFTextField name="linkedinUrl" label="LinkedIn Profile Url" />
                        </Stack>
                        <Stack spacing={1}>
                          <Box
                            rowGap={2}
                            columnGap={2}
                            display="flex"
                            gridTemplateColumns={{
                              xs: 'repeat(1, 1fr)',
                              sm: 'repeat(2, 1fr)',
                            }}
                          >
                            <Typography variant="subtitle2" mt={1}>
                              Ready to Relocate:
                            </Typography>
                            <RHFRadioGroup row spacing={2} name="readytolocate" options={yesNoArr} />
                          </Box>
                        </Stack>
                      </Box>
                    </>
                  )}

                  {/* ------------------------------------------------- Professional Details ----------------------------------------------------*/}
                  {activeStep === 2 && (
                    <>
                      <Box>
                        <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                          Professional Details:
                        </Typography>
                      </Box>
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        <Stack sx={{ textAlign: 'right' }}>
                          <RHFTextField
                            name="expinyrs"
                            type="number"
                            placeholder="0.0"
                            label="Experience in Years"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={blockInvalidChar}
                          />
                        </Stack>
                        <RHFTextField
                          name="relexp"
                          type="number"
                          placeholder="0.0"
                          label="Relevant Experience In Year"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={blockInvalidChar}
                          disabled={!expInYears}
                        />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="candQal"
                            placeholder="Highest Qualification"
                            label={
                              <div>
                                Qualification
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={qualArr}
                            getOptionLabel={(option) => option.masterName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.masterId}>
                                {option.masterName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="currentjob"
                            placeholder="Current Job Designation / Role"
                            label="Designation"
                            options={desgntnArr}
                            getOptionLabel={(option) => option.masterName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.masterId}>
                                {option.masterName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="currentcomp" label="Current Employer" />
                        <RHFTextField
                          name="noticeprd"
                          placeholder="Notice Period in Days"
                          type="number"
                          label="Notice Period"
                          onKeyDown={blockInvalidChar}
                        />
                        {fromInterviewList === false && (
                          <>
                            <RHFTextField
                              name="currentsal"
                              label="Current Salary"
                              placeholder="0.00"
                              type="number"
                              onKeyDown={blockInvalidChar}
                              onWheel={(e) => e.target.blur()}
                              InputLabelProps={{ shrink: true }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Box component="span" sx={{ color: 'text.disabled' }}>
                                      <RHFAutocomplete
                                        name="currentsalcurncy"
                                        defaultValue={{
                                          currencySymbol: '₹',
                                          countryName: 'India',
                                        }}
                                        filterOptions={filterCurrency}
                                        disableClearable
                                        sx={{
                                          '& fieldset': { border: 'none' },
                                        }}
                                        options={countryArr}
                                        getOptionLabel={(option) => option.currencySymbol}
                                        componentsProps={{
                                          popper: { style: { width: 'fit-content' } },
                                        }}
                                        onChange={(event, value) => {
                                          setValue('currentsalcurncy', value, { shouldValidate: true });
                                          trigger('currentsal');
                                        }}
                                        renderOption={(props, option) => (
                                          <li {...props} key={option.shortName}>
                                            {option.countryName}({option.currencySymbol})
                                          </li>
                                        )}
                                      />
                                    </Box>
                                  </InputAdornment>
                                ),
                              }}
                            />

                            <RHFTextField
                              name="exptsal"
                              label="Expected Salary"
                              placeholder="0.00"
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={blockInvalidChar}
                              InputLabelProps={{ shrink: true }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Box component="span" sx={{ color: 'text.disabled' }}>
                                      <RHFAutocomplete
                                        name="exptsalcurncy"
                                        defaultValue={{
                                          currencySymbol: '₹',
                                          countryName: 'India',
                                        }}
                                        filterOptions={filterCurrency}
                                        disableClearable
                                        sx={{
                                          '& fieldset': { border: 'none' },
                                        }}
                                        options={countryArr}
                                        getOptionLabel={(option) => option.currencySymbol}
                                        componentsProps={{
                                          popper: { style: { width: 'fit-content' } },
                                        }}
                                        onChange={(event, value) => {
                                          setValue('exptsalcurncy', value, { shouldValidate: true });
                                          trigger('exptsal');
                                        }}
                                        renderOption={(props, option) => (
                                          <li {...props} key={option.shortName}>
                                            {option.countryName}({option.currencySymbol})
                                          </li>
                                        )}
                                      />
                                    </Box>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </>
                        )}
                        <RHFAutocomplete
                          name="primaryskl"
                          label={
                            <div>
                              Primary Skills
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          placeholder="+ Primary Skills"
                          multiple
                          limitTags={3}
                          options={skillArr}
                          getOptionLabel={(option) => option?.skillName}
                          className="scrollOnly"
                          isOptionEqualToValue={(option, value) =>
                            option?.skillName === value?.skillName
                          }
                          onPaste={(event) => {
                            event.preventDefault();

                            const pastedText = event.clipboardData.getData('text');
                            if (!pastedText) return;

                            const pastedItems = pastedText
                              .split(/[\n,]+/)
                              .map((item) => item.trim())
                              .filter((item) => item.length > 0);

                            const allOptions = skillArr || [];

                            const currentPrimary = watch('primaryskl') || [];
                            const currentSecondary = watch('secondskl') || [];

                            const matched = allOptions.filter((option) => {
                              const label = option?.skillName.toLowerCase();

                              const isPasted = pastedItems.some((item) => item.toLowerCase() === label);

                              const isInPrimary = currentPrimary.some(
                                (priSkill) => priSkill?.skillName.toLowerCase() === label
                              );

                              const isInSecondary = currentSecondary.some(
                                (secSkill) => secSkill?.skillName.toLowerCase() === label
                              );

                              return isPasted && !isInPrimary && !isInSecondary;
                            });

                            const merged = [...currentPrimary, ...matched];

                            setValue('primaryskl', merged, { shouldValidate: true });
                            setPriSkillArr(merged);
                          }}
                          onChange={(event, value) => {
                            setPriSkillArr(value);
                            setValue('primaryskl', value, { shouldValidate: true });

                            const filteredSecSkills = secSkillArr.filter(
                              (secSkill) =>
                                !value.some((priSkill) => priSkill?.skillName === secSkill?.skillName)
                            );

                            setValue('secondskl', filteredSecSkills, { shouldValidate: true });
                            setSecSkillArr(filteredSecSkills);
                          }}
                          renderOption={(props, option) => (
                            <li {...props} key={option?.skillId}>
                              {`${option?.skillName}`}
                            </li>
                          )}
                          renderTags={(selected, getTagProps) => (
                            <Box
                              sx={{
                                maxHeight: 40,
                                overflowY: 'auto',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 0.5,
                              }}
                            >
                              {[...selected].reverse().map((option, index) => (
                                <Chip
                                  {...getTagProps({ index: selected.length - 1 - index })}
                                  key={option?.skillId}
                                  label={option?.skillName}
                                  size="small"
                                  color="info"
                                  variant="soft"
                                />
                              ))}
                            </Box>
                          )}
                        />
                        <RHFAutocomplete
                          name="secondskl"
                          label="Secondary Skills"
                          placeholder="+ Secondary Skills"
                          multiple
                          sx={{ mb: 2 }}
                          options={skillArr.filter(
                            (option) =>
                              !(watch('primaryskl') || []).some(
                                (selectedSkill) => selectedSkill?.skillName === option?.skillName
                              )
                          )}
                          getOptionLabel={(option) => option?.skillName}
                          isOptionEqualToValue={(option, value) =>
                            option?.skillName === value?.skillName
                          }
                          onPaste={(event) => {
                            event.preventDefault();

                            const pastedText = event.clipboardData.getData('text');
                            if (!pastedText) return;

                            const pastedItems = pastedText
                              .split(/[\n,]+/)
                              .map((item) => item.trim())
                              .filter((item) => item.length > 0);

                            const allOptions = skillArr || [];

                            const currentPrimary = watch('primaryskl') || [];
                            const currentSecondary = watch('secondskl') || [];

                            const matched = allOptions.filter((option) => {
                              const label = option?.skillName.toLowerCase();

                              const isPasted = pastedItems.some((item) => item.toLowerCase() === label);

                              const isInSecondary = currentSecondary.some(
                                (secSkill) => secSkill?.skillName.toLowerCase() === label
                              );

                              const isInPrimary = currentPrimary.some(
                                (priSkill) => priSkill?.skillName.toLowerCase() === label
                              );

                              return isPasted && !isInSecondary && !isInPrimary;
                            });

                            const merged = [...currentSecondary, ...matched];

                            setValue('secondskl', merged, { shouldValidate: true });
                            setSecSkillArr(merged);
                          }}
                          onChange={(event, value) => {
                            setSecSkillArr(value);
                            setValue('secondskl', value, { shouldValidate: true });
                          }}
                          renderOption={(props, option) => (
                            <li {...props} key={option?.skillId}>
                              {`${option?.skillName}`}
                            </li>
                          )}
                          renderTags={(selected, getTagProps) =>
                            selected.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option?.skillId}
                                label={option?.skillName}
                                size="small"
                                color="info"
                                variant="soft"
                              />
                            ))
                          }
                        />
                        <Stack spacing={2}>
                          <Box
                            rowGap={2.5}
                            columnGap={2}
                            display="flex"
                            flexWrap="wrap"
                            gridTemplateColumns={{
                              xs: 'repeat(1, 1fr)',
                              sm: 'repeat(2, 1fr)',
                            }}
                          >
                            <Typography variant="subtitle2" mt={1}>
                              Is Currently Working With This Employer?:
                            </Typography>
                            <RHFRadioGroup
                              row
                              spacing={2}
                              name="iscurrentemp"
                              options={yesNoArr}
                              onChange={(event, value) => {
                                setValue('iscurrentemp', value, { shouldValidate: true });
                                if (value === 'true') {
                                  setValue('hasresigned', 'false', { shouldValidate: true });
                                }
                              }}
                            />
                          </Box>
                        </Stack>
                        <Stack spacing={2} marginLeft={1}>
                          <Box
                            rowGap={2.5}
                            columnGap={2}
                            display="flex"
                            flexWrap="wrap"
                            gridTemplateColumns={{
                              xs: 'repeat(1, 1fr)',
                              sm: 'repeat(2, 1fr)',
                            }}
                          >
                            <Typography variant="subtitle2" mt={1}>
                              Has Resigned:
                            </Typography>
                            <RHFRadioGroup
                              row
                              spacing={2}
                              name="hasresigned"
                              options={yesNoArr}
                              disabled={watch('iscurrentemp') === 'true'}
                              onChange={(event, value) => {
                                setValue('hasresigned', value, { shouldValidate: true });
                                if (value !== 'true') {
                                  setValue('resigneddate', null, { shouldValidate: true });
                                }
                                trigger('resigneddate');
                                trigger('canjoinby');
                              }}
                            />
                          </Box>
                        </Stack>
                        {(watch('hasresigned') === true || watch('hasresigned') === 'true') && (
                          <Controller
                            name="resigneddate"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                              <DatePicker
                                label={
                                  <div>
                                    Resignation Date
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                value={field.value ?? null}
                                onChange={(newValue) => {
                                  field.onChange(newValue);
                                  trigger('canjoinby');
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!error,
                                    helperText: error?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        )}

                        <Controller
                          name="canjoinby"
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <DatePicker
                              label="Can Join By"
                              value={field.value ?? null}
                              onChange={(newValue) => {
                                field.onChange(newValue);
                              }}
                              minDate={new Date()}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!error,
                                  helperText: error?.message,
                                },
                              }}
                            />
                          )}
                        />
                      </Box>
                    </>
                  )}
                  {/* ----------------------------- Education Details ---------------------------------------------------------------- */}
                  {activeStep === 3 && (
                    <CandNewEditEduCompo
                      universityData={universityArr}
                      qualData={qualArr}
                      qualTypeData={qualTypeArr}
                      streamData={streamArr}
                      candidateData={currentCand}
                      candidateEduData={currentCandEduDtl}
                    />
                  )}
                  {/* ----------------------------- Certificate Details ---------------------------------------------------------------- */}
                  {activeStep === 4 && (
                    <CandNewEditCertiCompo certNmArr={certNmArr} certInstNmArr={certInstNmArr} />
                  )}
                  {/* ----------------------------- Experience Details ---------------------------------------------------------------- */}
                  {/* Experience Section */}
                  {activeStep === 5 && (
                    <>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={switchState.experience}
                            onChange={(event) => handleSwitchChange(event, 'experience')}
                            name="expSwitch"
                            color="primary"
                          />
                        }
                        label="Have an Experience ?"
                      />

                      {/* Render CandNewEditExpCompo if the experience switch is on */}
                      {switchState.experience && (
                        <CandNewEditExpCompo
                          desgData={desgntnArr}
                          cntryData={countryArr}
                          filterCurrency={filterCurrency}
                          switchState={switchState}
                          onEmptyExperience={handleNoExperience}
                          fromInterviewList={fromInterviewList}
                        />
                      )}
                    </>
                  )}

                  {/* ----------------------------- Reference Details ---------------------------------------------------------------- */}

                  {activeStep === steps.length - 1 ? (
                    // Final Step Buttons
                    <>
                      <CandNewEditRefCompo desgRefData={desgntnArr} />

                      {!currentCandView && (
                        <Stack justifyContent="flex-end" direction="row" spacing={2} sx={{ mt: 3 }}>
                          {/* Back Button */}
                          {!disabled && activeStep > 0 && (
                            <Button
                              variant="soft"
                              onClick={handleBack}
                              sx={{
                                color: '#00838f',
                                bgcolor: '#CAFDF5',
                                '&:hover': {
                                  bgcolor: '#CAFDF5',
                                },
                              }}
                            >
                              Previous
                            </Button>
                          )}
                          {/* Save Changes / Submit Button */}
                          {!disabled && (
                            <LoadingButton
                              type="button"
                              variant="soft"
                              color="success"
                              sx={{ mr: 1 }}
                              disabled={isGenerating}
                              onClick={async () => {
                                if (activeStep === steps.length - 1) {
                                  const isValid = await validateAllSteps();
                                  if (!isValid) {
                                    enqueueSnackbar('Please complete all required steps before submitting.', {
                                      variant: 'warning',
                                    });
                                    return;
                                  }
                                  confirmFinalSubmit.onTrue();
                                } else {
                                  setSavingAction('saveNext');
                                  try {
                                    await handleSaveNext();
                                  } finally {
                                    setSavingAction(null);
                                  }
                                }
                              }}
                            >
                              {savingAction === 'saveNext' ? (
                                <>
                                  <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                  Saving...
                                </>
                              ) : activeStep === steps.length - 1 ? (
                                'Submit Form'
                              ) : (
                                'Save & Next'
                              )}
                            </LoadingButton>
                          )}
                        </Stack>
                      )}
                    </>
                  ) : (
                    // Steps Before Final Step
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mt: 3,
                      }}
                    >
                      {/* Back Button */}
                      {!disabled && activeStep > 0 && (
                        <Button
                          variant="soft"
                          onClick={handleBack}
                          sx={{
                            mr: 2,
                            color: '#00838f',
                            bgcolor: '#CAFDF5',
                            '&:hover': {
                              bgcolor: '#CAFDF5',
                            },
                          }}
                        >
                          Previous
                        </Button>
                      )}
                      {/* Spacer to push other buttons to the right */}
                      <Box sx={{ flexGrow: 1 }} />

                      {!disabled && (
                        <>
                          {/* For Existing Employee: Show Save Changes button */}
                          {currentCand && (
                            <LoadingButton
                              type="button"
                              variant="soft"
                              color="success"
                              sx={{ mr: 1 }}
                              disabled={isGenerating}
                              onClick={async () => {
                                setSavingAction('saveOnly');
                                try {
                                  await handleFormSubmission(methods.getValues(), false);
                                } finally {
                                  setSavingAction(null);
                                }
                              }}
                            >
                              {savingAction === 'saveOnly' ? (
                                <>
                                  <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                  Saving...
                                </>
                              ) : (
                                'Save Changes'
                              )}
                            </LoadingButton>
                          )}
                          {!currentCand && activeStep === 0 ? (
                            <Button
                              variant="soft"
                              onClick={handleNext}
                              sx={{
                                mr: 1,
                                color: '#026544',
                                bgcolor: '#77ed8b7a',
                                '&:hover': { bgcolor: 'success.light' },
                              }}
                            >
                              Next
                            </Button>
                          ) : (
                            <LoadingButton
                              type="button"
                              variant="soft"
                              sx={{
                                mr: 1,
                                color: '#026544',
                                bgcolor: '#77ed8b7a',
                                '&:hover': { bgcolor: 'success.light' },
                              }}
                              disabled={isGenerating}
                              onClick={async () => {
                                setIsSavingNext(true);
                                setIsGenerating(true);
                                try {
                                  await handleSaveNext();
                                } finally {
                                  setIsGenerating(false);
                                }
                              }}
                            >
                              {isGenerating && isSavingNext ? (
                                <>
                                  <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                  Saving...
                                </>
                              ) : (
                                'Save & Next'
                              )}
                            </LoadingButton>
                          )}
                        </>
                      )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </FormProvider>
            <>
              {disabled && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 1,
                  }}
                >
                  {activeStep > 0 && (
                    <Button
                      variant="soft"
                      onClick={handleBack}
                      sx={{
                        color: '#00838f',
                        bgcolor: '#CAFDF5',
                        '&:hover': {
                          bgcolor: '#CAFDF5',
                        },
                      }}
                    >
                      Previous
                    </Button>
                  )}

                  {activeStep !== steps.length - 1 && currentCand && (
                    <Button
                      variant="soft"
                      onClick={handleNext}
                      sx={{
                        color: '#026544',
                        bgcolor: '#77ed8b7a',
                        '&:hover': {
                          bgcolor: 'success.light',
                        },
                      }}
                    >
                      Next
                    </Button>
                  )}
                </Box>
              )}
            </>
          </Card>
        </Box>
      </Container>
      {/* ------------------------------------------------ Autofill resume Section --------------------------------------------------------*/}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={quickAutoFill.value}
        onClose={quickAutoFill.onFalse}
      >
        <DialogTitle>Autofill</DialogTitle>
        <DialogContent>
          <Typography variant="body1">How do you want to process the resume?</Typography>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            onClick={() => {
              quickAutoFill.onFalse();
              setIsAutoFilled(true);
              handleAutoFillResume();
            }}
          >
            Autofill with Resume
          </LoadingButton>
          <Button
            variant="outlined"
            onClick={() => {
              quickAutoFill.onFalse();
              setIsAutoFilled(false);
            }}
          >
            Fill Form Manually
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        open={confirmFinalSubmit.value}
        onClose={confirmFinalSubmit.onFalse}
        title="Confirm Application Submission"
        content="Are you sure you want to submit your application? Once submitted, your details will be finalized and sent to the recruitment team for review."
        action={
          <LoadingButton
            variant="contained"
            color="success"
            loading={isSubmittingFinal}
            onClick={async () => {
              try {
                setIsSubmittingFinal(true);
                await handleFinalSubmitClick();
                confirmFinalSubmit.onFalse();
              } finally {
                setIsSubmittingFinal(false);
              }
            }}
          >
            Confirm & Submit
          </LoadingButton>
        }
      />
    </>
  );
}
CandidateNewEditForm.propTypes = {
  currentCand: PropTypes.object,
  currentCandPrefLoc: PropTypes.array,
  currentCandEduDtl: PropTypes.array,
  currentCandSkils: PropTypes.array,
  currentCandCertDtl: PropTypes.array,
  currentCandExpDtl: PropTypes.array,
  currentCandRefDtl: PropTypes.array,
  currentCandView: PropTypes.bool,
  disabled: PropTypes.bool,
  fromInterviewList: PropTypes.bool,
};
CandidateNewEditForm.defaultProps = {
  fromInterviewList: false,
};
